/*!
 * In Your Corner — presale landing section for Shopify.
 * Plain JavaScript, no dependencies, no build step at runtime.
 * Every function, class, id and data attribute uses the "iyc" prefix.
 * Cart and checkout use Shopify's own AJAX Cart API and /checkout.
 */
(function () {
  'use strict';

  // Sprachen (27.09.2026): Texte über window.IYC_T (snippets/iyc-js-texte.liquid, nur auf ru/de-Seiten gesetzt).
  // Ohne IYC_T geben T/TF/TN genau den englischen Text zurück.
  var IYC_T = window.IYC_T || null;
  function T(s) { return (IYC_T && IYC_T[s]) || s; }
  function TF(s, v) {
    var r = T(s);
    Object.keys(v || {}).forEach(function (k) { r = r.split('{' + k + '}').join(String(v[k])); });
    return r;
  }
  function iycPluralIndex(n) {
    var l = (IYC_T && IYC_T._lang) || 'en';
    if (l === 'ru') {
      var a = n % 10, b = n % 100;
      return a === 1 && b !== 11 ? 0 : (a >= 2 && a <= 4 && (b < 12 || b > 14) ? 1 : 2);
    }
    return n === 1 ? 0 : 1;
  }
  function TN(n, eins, viele, v, istEins) {
    var formen = IYC_T && IYC_T[eins + '|' + viele];
    var f = formen ? (formen[iycPluralIndex(n)] || formen[formen.length - 1]) : (istEins ? eins : viele);
    var w = { n: n };
    Object.keys(v || {}).forEach(function (k) { w[k] = v[k]; });
    return TF(f, w);
  }

  var root = document.querySelector('.iyc-root');
  if (!root || root.getAttribute('data-iyc-ready')) return;
  root.setAttribute('data-iyc-ready', '1');

  var cfgEl = document.getElementById('iyc-config');
  var iycCfg = {};
  try {
    iycCfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}');
  } catch (e) {
    iycCfg = {};
  }

  function iycQ(sel, scope) {
    return (scope || root).querySelector(sel);
  }
  function iycQA(sel, scope) {
    return Array.prototype.slice.call((scope || root).querySelectorAll(sel));
  }

  /* ---------- analytics: dataLayer only, no IDs ---------- */
  var iycTrackQ = [];
  var iycTrackT = 0;
  function iycTrackFlush() {
    clearTimeout(iycTrackT);
    var q = iycTrackQ;
    iycTrackQ = [];
    for (var i = 0; i < q.length; i++) (window.dataLayer = window.dataLayer || []).push(q[i]);
  }
  window.addEventListener('pagehide', iycTrackFlush);
  /* KL1 05.10.2026: while the order layer redraws itself after a country switch, nothing new happened – no events. */
  var iycRuhig = false;
  function iycTrack(event, params) {
    if (iycRuhig) return;
    var payload = { event: event, campaign_id: 'iyc-presale', page: location.pathname };
    if (params) {
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k) && !/mail|name|phone|address/i.test(k)) payload[k] = params[k];
      }
    }
    /* W2b 02.10.2026: GTM arbeitet jedes dataLayer.push sofort ab (gemessen ≈ 35 ms je Ereignis, gtag ≈ 500 ms bei 4× CPU).
       Ereignisse warten deshalb bis nach dem nächsten Bild – die Ebene ist zuerst sichtbar. Vor einem Seitenwechsel
       (begin_checkout, Express, pagehide) wird sofort geleert. */
    iycTrackQ.push(payload);
    if (event === 'begin_checkout' || event === 'express_checkout_click' || event === 'checkout_error') iycTrackFlush();
    else if (iycTrackQ.length === 1) {
      if (window.requestAnimationFrame) requestAnimationFrame(function () { setTimeout(iycTrackFlush, 0); });
      clearTimeout(iycTrackT);
      iycTrackT = setTimeout(iycTrackFlush, 500);
    }
    /* M1 30.09.2026: measurement only. Cart funnel steps as Clarity events (Clarity loads with consent only):
       warenkorb_offen -> weiter_zur_kasse (click on "Continue to secure checkout") -> kasse_wird_geladen
       (cart written, redirect to /checkout) or kasse_fehler. */
    try {
      var ce = (IYC_CLARITY_EVENTS || {})[event];
      if (event === 'begin_checkout') ce = (params && params.source) ? 'weiter_zur_kasse' : 'kasse_wird_geladen';
      if (ce && window.clarity) window.clarity('event', ce);
    } catch (e) {}
  }
  var IYC_CLARITY_EVENTS = { cart_icon_open: 'warenkorb_offen', view_cart_drawer: 'warenkorb_offen', view_cart: 'weiter_zur_kasse', checkout_error: 'kasse_fehler' };

  function iycTrackOnView(el, event) {
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        iycTrack(event);
        io.disconnect();
      }
    }, { threshold: 0.5 });
    io.observe(el);
  }

  /* ---------- money ---------- */
  /* uae-launch 22.10.2026: AED als „AED 199“ (glatt ohne .00), andere Währungen unverändert */
  function iycAedKurz(s) { return /^Dhs\. /.test(s) ? 'AED ' + s.slice(5).replace(/\.00$/, '') : s; }
  function iycFormatMoney(cents) { return iycAedKurz(iycFormatMoney0(cents)); }
  function iycFormatMoney0(cents) {
    var format = iycCfg.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------- sticky mobile bar ---------- */
  /* ---------- KL1 05.10.2026: country switch without a page load ---------- */
  /* Noah: "Ich muss doch da drinnen bleiben im Checkout" – and then: no reload at all, only euro/dollar prices and
     shipping change in the open layer. After the switch the page is fetched again in the new market and the texts of
     the current page are brought up to date in place (iycAbgleich): old and new tree are walked side by side; a text
     that differs is replaced, a block whose structure differs (country-specific lines, e.g. AT reason, VAT row) is
     replaced as a whole as long as it holds nothing interactive. Everything script-driven keeps its node, so no
     listener is lost: counters, timers, revealed headings (same text, other structure -> left alone), the layer's
     own lines and totals (render() draws them again from the new prices). */
  var IYC_AB_SKIP = '.v2c-promo__timer, .iyc-clock-units, .iyc-kl-cd, [data-v2c-timer], #iyc-lines, #iyc-cm-lines, ' +
    '#iyc-subtotal, #iyc-cm-subtotal, #iyc-books-total, #iyc-ladder, #iyc-crew-msg, [data-iyc-x-slot], [data-iyc-express], ' +
    '[data-iyc-step-label], [data-iyc-wb-diff], #iyc-checkout-error, [data-iyc-promo-n], .v2c-cart-count, .iyc-lwk, .iyc-lw, ' +
    '[data-iyc-pdp-total], [data-iyc-cta-label]';
  var IYC_AB_TAG = { SCRIPT: 1, STYLE: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1, IFRAME: 1, META: 1 };
  var IYC_AB_LEBT = 'input, button, select, textarea, form, details, summary, video, iframe, [id], [data-iyc-preorder], [data-iyc-cart-open], [data-iyc-pdp-add]';
  function iycAbgleich(alt, neu, stat) {
    function zaehlt(n) {
      if (n.nodeType === 3) return /\S/.test(n.nodeValue);
      if (n.nodeType !== 1 || IYC_AB_TAG[n.tagName]) return false;
      return n.id !== 'iyc-order' && n.id !== 'iyc-cart' && n.id !== 'iyc-config';
    }
    function kinder(el) { return Array.prototype.filter.call(el.childNodes, zaehlt); }
    function sig(n) { return n.nodeType === 3 ? '#t' : n.tagName + '#' + (n.id || ''); }
    function text(el) { return String(el.textContent || '').replace(/\s+/g, ' ').trim(); }
    function lauf(a, n) {
      if (a.matches && a.matches(IYC_AB_SKIP)) return;
      var ka = kinder(a), kn = kinder(n);
      var gleich = ka.length === kn.length && ka.every(function (k, i) { return sig(k) === sig(kn[i]); });
      if (!gleich) {
        // other structure: same words (e.g. a heading split into words for its reveal) -> leave it;
        // other words and nothing interactive inside -> take the new block as a whole
        if (text(a) === text(n)) return;
        if (!a.querySelector(IYC_AB_LEBT)) {
          while (a.firstChild) a.removeChild(a.firstChild);
          Array.prototype.forEach.call(n.childNodes, function (k) { a.appendChild(document.importNode(k, true)); });
          stat.blocks++;
          return;
        }
        stat.offen.push((a.id ? '#' + a.id : a.tagName.toLowerCase() + '.' + String(a.getAttribute('class') || '').split(' ')[0]));
        // walk what still lines up (same signature in order), skip the rest
        var j = 0;
        ka.forEach(function (k) {
          for (var t = j; t < kn.length; t++) {
            if (sig(kn[t]) === sig(k)) { if (k.nodeType === 1) lauf(k, kn[t]); j = t + 1; return; }
          }
        });
        return;
      }
      for (var i = 0; i < ka.length; i++) {
        if (ka[i].nodeType === 3) {
          if (ka[i].nodeValue.trim() !== kn[i].nodeValue.trim()) { ka[i].nodeValue = kn[i].nodeValue; stat.texts++; }
        } else lauf(ka[i], kn[i]);
      }
    }
    lauf(alt, neu);
    return stat;
  }
  /* KL1: PayPal's SDK fixes the currency when it loads (paypal.com/sdk/js?currency=EUR) and refuses a second copy in
     the same window ("Can not register multiple components with the same tag: paypal-buttons", measured 05.10.) – after
     the switch the PayPal button was gone. Clearing the old copy (script, window.paypal, its zoid/post-robot globals)
     lets the refreshed buttons load it in the new currency (measured: PayPal button in USD, no error). */
  function iycPaypalWeg() {
    try {
      Object.getOwnPropertyNames(window).forEach(function (k) {
        if (/^__zoid_|^__post_robot_|^paypal-https/.test(k)) { try { delete window[k]; } catch (e) { window[k] = undefined; } }
      });
      try { delete window.paypal; } catch (e) { window.paypal = undefined; }
      Array.prototype.forEach.call(document.querySelectorAll('script[src*="paypal.com/sdk/js"]'), function (sc) { sc.parentNode.removeChild(sc); });
    } catch (e) {}
  }
  /* the country chooser blocks (snippets/iyc-land-wahl.liquid) carry a form, so they are swapped as a whole, in order */
  function iycTausche(sel, scope, doc) {
    var alt = Array.prototype.slice.call(scope.querySelectorAll(sel));
    var neu = Array.prototype.slice.call(doc.querySelectorAll(sel));
    alt.forEach(function (a, i) { if (neu[i]) a.parentNode.replaceChild(document.importNode(neu[i], true), a); });
    return alt.length;
  }

  function iycInitSticky() {
    var bar = iycQ('.iyc-sticky');
    var heroCta = (document.documentElement.classList.contains('iyc-ebook') && document.getElementById('iyc-eb-hero-link')) || document.getElementById('iyc-hero-preorder-link');   // eBook weltweit 28.10.2026: im eBook-Modus der eBook-Knopf
    if (!bar || !heroCta) return;
    var offerCta = document.getElementById('iyc-offer-preorder-link');
    var finalCta = document.getElementById('iyc-final-bundle-link') || document.getElementById('iyc-final-hardcover-link');
    function iycInView(el) {
      if (!el) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = el.getBoundingClientRect();
      return r.top < vh - 40 && r.bottom > 40;
    }
    var seen = false;
    function update() {
      var ctaVisible = iycInView(offerCta) || iycInView(finalCta);
      // 23.09.2026: shown from the first screen whenever the hero button itself is not in view
      var on = !iycInView(heroCta) && !root.classList.contains('iyc-order-open') && !root.classList.contains('iyc-cart-open') && !ctaVisible;
      // plain white button while the hero button is still below the first screen, gold bar with price after scrolling past it
      bar.classList.toggle('iyc-sticky--hero', heroCta.getBoundingClientRect().top > 0);
      bar.classList.toggle('iyc-is-on', on);
      if (on) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
      if (on && !seen && getComputedStyle(bar).display !== 'none') {
        seen = true;
        iycTrack('sticky_cta_view');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* KL-01-10 (01.10.2026, Noah: „nach Accept rutscht sie unter den Rand, erst nach Scrollen wieder“): die Knöpfe wandern
       auch ohne Scrollen (Hero wächst nach der Cookie-Wahl um rund 75 px, Bilder laden nach). Vorher rechnete update() nur
       bei scroll/resize und blieb bis zum nächsten Scrollen beim alten Stand. Der Beobachter meldet jedes Überschreiten
       der 40-px-Grenzen von iycInView. */
    if ('IntersectionObserver' in window) {
      var iycStickyIo = new IntersectionObserver(function () { update(); }, { rootMargin: '-40px 0px -40px 0px', threshold: [0, 1] });
      [heroCta, offerCta, finalCta].forEach(function (el) { if (el) iycStickyIo.observe(el); });
    }
    update();
    return update;
  }

  /* ---------- lazy background ---------- */
  function iycInitLazyBg() {
    var el = iycQ('[data-iyc-lazy-bg]');
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      el.classList.add('iyc-is-loaded');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        el.classList.add('iyc-is-loaded');
        io.disconnect();
      }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  /* ---------- book page viewer ---------- */
  function iycInitViewer() {
    var stage = iycQ('.iyc-stage');
    if (!stage) return;
    var strip = iycQ('.iyc-vstrip', stage);
    var leaves = iycQA('.iyc-leaf', stage);
    var cur = iycQ('[data-iyc-cur]');
    var cap = iycQ('p[data-iyc-cap]');
    var thumbs = iycQA('[data-iyc-go]');
    var prev = iycQ('[data-iyc-dir="-1"]');
    var next = iycQ('[data-iyc-dir="1"]');
    if (!strip || !cur || !cap || !prev || !next || !leaves.length) return;
    var index = 0;
    function show(n, source) {
      index = Math.max(0, Math.min(leaves.length - 1, n));
      strip.style.transform = 'translateX(' + -index * 100 + '%)';
      cur.textContent = String(index + 1);
      cap.textContent = leaves[index].getAttribute('data-iyc-title') || '';
      leaves.forEach(function (l, k) {
        if (k === index) l.removeAttribute('aria-hidden');
        else l.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === index)); });
      prev.disabled = index === 0;
      next.disabled = index === leaves.length - 1;
      if (source) iycTrack('book_page_view', { page_index: index + 1, source: source });
    }
    prev.addEventListener('click', function () { show(index - 1, 'arrow'); });
    next.addEventListener('click', function () { show(index + 1, 'arrow'); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.getAttribute('data-iyc-go')), 'thumbnail'); });
    });
    stage.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight') { ev.preventDefault(); show(index + 1, 'keyboard'); }
      else if (ev.key === 'ArrowLeft') { ev.preventDefault(); show(index - 1, 'keyboard'); }
    });
    var startX = null;
    stage.addEventListener('pointerdown', function (ev) { startX = ev.clientX; });
    stage.addEventListener('pointerup', function (ev) {
      if (startX === null) return;
      var dx = ev.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1), 'swipe');
      else if (Math.abs(dx) < 8 && ev.button === 0) lupe.auf(index, 'tap');
    });
    stage.addEventListener('pointercancel', function () { startX = null; });
    /* BV3110 31.10.2026 (Clarity mobil 7 Tage, 96 Dead Clicks auf der Startseite): Seitenbild antippen öffnet die Seite
       als Lupe (snippets/iyc-leseprobe-lupe.liquid), die angeschnittenen Nachbarseiten blättern, die Teil-Karten
       (Fighter/Coach/Legacy) zeigen die Leseprobe aus ihrem Teil. */
    stage.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); lupe.auf(index, 'keyboard'); }
    });
    var fanL = iycQ('.iyc-fan-l');
    var fanR = iycQ('.iyc-fan-r');
    if (fanL) fanL.addEventListener('click', function () { show(index - 1, 'fan'); });
    if (fanR) fanR.addEventListener('click', function () { show(index + 1, 'fan'); });
    iycQA('[data-iyc-teil]').forEach(function (k) {
      k.addEventListener('click', function (ev) {
        ev.preventDefault();
        show(Number(k.getAttribute('data-iyc-teil')), 'part');
        var ziel = iycQ('.iyc-reader') || stage;
        var r = ziel.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    var lupe = iycLeseLupe(leaves, function () { return index; }, function (n) { show(n, null); });
    show(0, null);
  }

  /* BV3110: Lupe der Leseprobe (Startseite). Zoom per Antippen wie auf der Produktseite (sections/iyc-product.liquid). */
  function iycLeseLupe(leaves, holeIndex, setzeIndex) {
    var lb = iycQ('[data-iyc-rd-lb]');
    var leer = { auf: function () {} };
    if (!lb) return leer;
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    var img = iycQ('[data-iyc-rd-img]', lb);
    var cap = iycQ('[data-iyc-rd-cap]', lb);
    var buehne = iycQ('[data-iyc-rd-stage]', lb);
    var links = iycQ('[data-iyc-rd-step="-1"]', lb);
    var rechts = iycQ('[data-iyc-rd-step="1"]', lb);
    if (!img || !cap || !buehne || !links || !rechts) return leer;
    var i = 0, zuvor = null, timer = 0, FAKTOR = 2.2;
    function breitestes(bild) {
      var set = bild.getAttribute('srcset') || '';
      var best = bild.currentSrc || bild.src, breite = 0;
      set.split(',').forEach(function (teil) {
        var t = teil.trim().split(/\s+/);
        var w = parseInt(t[1], 10);
        if (t[0] && w > breite) { breite = w; best = t[0]; }
      });
      return best;
    }
    function zoomAus() {
      if (!buehne.classList.contains('is-zoom')) return;
      buehne.classList.remove('is-zoom');
      buehne.style.width = buehne.style.height = img.style.width = img.style.height = '';
    }
    function zoomAn(x, y) {
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (x - r.left) / r.width, py = (y - r.top) / r.height;
      buehne.style.width = Math.round(r.width) + 'px';
      buehne.style.height = Math.round(r.height) + 'px';
      buehne.classList.add('is-zoom');
      img.style.width = Math.round(r.width * FAKTOR) + 'px';
      img.style.height = Math.round(r.height * FAKTOR) + 'px';
      buehne.scrollLeft = Math.max(0, px * r.width * FAKTOR - r.width / 2);
      buehne.scrollTop = Math.max(0, py * r.height * FAKTOR - r.height / 2);
      iycTrack('book_page_zoom', { page_index: i + 1 });
    }
    function zeig(n) {
      zoomAus();
      i = Math.max(0, Math.min(leaves.length - 1, n));
      var bild = iycQ('img', leaves[i]);
      if (bild) {
        /* erst das schon geladene Bild der Leseprobe, dann die große Fassung nachladen (kein weißes Blatt) */
        var url = breitestes(bild), jetzt = i;
        img.src = bild.currentSrc || bild.src;
        img.alt = bild.getAttribute('alt') || '';
        if (url !== img.src) {
          var vor = new Image();
          vor.onload = function () { if (i === jetzt) img.src = url; };
          vor.src = url;
        }
      }
      cap.textContent = (leaves[i].getAttribute('data-iyc-title') || '') + ' \u00b7 ' + (i + 1) + ' / ' + leaves.length;
      links.disabled = i === 0;
      rechts.disabled = i === leaves.length - 1;
      if (i !== holeIndex()) setzeIndex(i);
    }
    function auf(n, quelle) {
      zuvor = document.activeElement;
      clearTimeout(timer);
      lb.hidden = false;
      zeig(n);
      document.documentElement.classList.add('iyc-rd-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { lb.classList.add('is-open'); }); });
      var x = iycQ('.iyc-rd-lb-x', lb);
      if (x) x.focus({ preventScroll: true });
      iycTrack('book_page_open', { page_index: i + 1, source: quelle || '' });
    }
    function zu() {
      zoomAus();
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('iyc-rd-lock');
      timer = setTimeout(function () { lb.hidden = true; }, 200);
      if (zuvor && zuvor.focus) zuvor.focus({ preventScroll: true });
    }
    buehne.addEventListener('click', function (e) {
      if (buehne.classList.contains('is-zoom')) zoomAus(); else zoomAn(e.clientX, e.clientY);
    });
    iycQA('[data-iyc-rd-zu]', lb).forEach(function (b) { b.addEventListener('click', zu); });
    links.addEventListener('click', function () { zeig(i - 1); });
    rechts.addEventListener('click', function () { zeig(i + 1); });
    var sx = null;
    buehne.addEventListener('touchstart', function (e) { sx = buehne.classList.contains('is-zoom') ? null : e.touches[0].clientX; }, { passive: true });
    buehne.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      sx = null;
      if (Math.abs(dx) > 50) { e.preventDefault(); zeig(i + (dx < 0 ? 1 : -1)); }
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { if (buehne.classList.contains('is-zoom')) zoomAus(); else zu(); }
      else if (e.key === 'ArrowRight') zeig(i + 1);
      else if (e.key === 'ArrowLeft') zeig(i - 1);
      else if (e.key === 'Tab') {
        var f = iycQA('button', lb).filter(function (b) { return !b.disabled && b.offsetParent !== null; });
        if (!f.length) return;
        var erst = f[0], letzt = f[f.length - 1];
        if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
        else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
      }
    });
    return { auf: auf };
  }

  /* ---------- presale clock (real end date from the theme editor only) ---------- */
  function iycPad(n) {
    return (n < 10 ? '0' : '') + n;
  }
  function iycRemaining(endMs, nowMs) {
    var t = Math.max(0, endMs - nowMs);
    var s = Math.floor(t / 1000);
    return { done: t === 0, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }
  function iycShortText(r) {
    if (r.done) return T('now');
    if (r.d >= 2) return TN(r.d, '{n} day', '{n} days', null, r.d === 1);
    if (r.d === 1) return TF('1 day {h} h', { h: r.h });
    return TF('{h} h {m} min', { h: r.h, m: iycPad(r.m) });
  }
  function iycInitClock() {
    var full = iycQA('[data-iyc-presale-clock]');
    var short = iycQA('[data-iyc-presale-clock-short]');
    var all = full.concat(short);
    if (!all.length) return;
    var end = Date.parse(all[0].getAttribute('data-iyc-end') || '');
    if (isNaN(end)) {
      all.forEach(function (el) {
        var box = el.closest('.iyc-stack-clock') || el.closest('.iyc-clock');
        if (box) box.hidden = true;
      });
      return;
    }
    var timer = 0;
    function tick() {
      var r = iycRemaining(end, Date.now());
      full.forEach(function (el) {
        iycQA('[data-iyc-u]', el).forEach(function (u) {
          var k = u.getAttribute('data-iyc-u');
          u.textContent = k === 'd' ? String(r.d) : iycPad(r[k]);
        });
        var units = iycQ('.iyc-clock-units', el);
        var closed = iycQ('.iyc-clock-closed', el);
        if (units) units.hidden = r.done;
        if (closed) closed.hidden = !r.done;
      });
      short.forEach(function (el) { el.textContent = iycShortText(r); });
      if (r.done) stop();
    }
    function start() { if (!timer) timer = window.setInterval(tick, 1000); }
    function stop() { clearInterval(timer); timer = 0; }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else { tick(); start(); }
    });
    tick();
    start();
  }

  /* ---------- FAQ + rules tracking ---------- */
  function iycInitFaq() {
    iycQA('details[data-iyc-faq]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) iycTrack('faq_open', { question_id: d.getAttribute('data-iyc-faq') });
      });
    });
    iycQA('[data-iyc-rules]').forEach(function (a) {
      a.addEventListener('click', function () { iycTrack('giveaway_rules_click'); });
    });
  }

  /* ---------- reminder dialog (desktop exit intent, Shopify customer form) ---------- */
  function iycStore(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }
  function iycInitReminder() {
    var dialog = document.getElementById('iyc-reminder');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var form = iycQ('form', dialog);
    var msg = iycQ('.iyc-form-msg', dialog);
    var close = iycQ('[data-iyc-close]', dialog);
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (ev) { if (ev.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      if (!iycStore('iyc.reminder.done')) iycStore('iyc.reminder.dismissedAt', String(Date.now()));
      iycTrack('reminder_dialog_close');
    });

    if (iycQ('[data-iyc-posted]', dialog)) {
      iycStore('iyc.reminder.done', '1');
      dialog.showModal();
      return;
    }
    var desktop = window.matchMedia('(min-width: 901px) and (pointer: fine)').matches;
    if (!desktop || iycStore('iyc.reminder.done')) return;
    if (Date.now() - Number(iycStore('iyc.reminder.dismissedAt') || 0) < 7 * 864e5) return;

    var engaged = false;
    var shown = false;
    window.addEventListener('scroll', function () {
      var depth = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (depth > 0.35) engaged = true;
    }, { passive: true });
    setTimeout(function () { engaged = true; }, 45000);
    document.addEventListener('mouseout', function (ev) {
      if (ev.relatedTarget || ev.clientY > 0 || shown || !engaged) return;
      if (document.querySelector('dialog[open]') || root.classList.contains('iyc-order-open')) return;
      shown = true;
      dialog.showModal();
      iycTrack('reminder_dialog_view');
    });

    if (form) {
      form.addEventListener('submit', function (ev) {
        var address = iycQ('input[type="email"]', form);
        var consent = iycQ('input[name="iyc-consent"]', form);
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((address.value || '').trim());
        if (!ok || !consent.checked) {
          ev.preventDefault();
          msg.setAttribute('data-iyc-kind', 'error');
          msg.textContent = !ok ? T('Please enter a valid email address.') : T('Please confirm that we may send you emails.');
          (!ok ? address : consent).focus();
          if (!ok) address.setAttribute('aria-invalid', 'true');
          return;
        }
        iycTrack('reminder_submit', { consent: true });
      });
    }
  }

  /* ---------- order overlay: upgrade -> review -> Shopify checkout ---------- */
  /* ---------- X1 30.09.2026: express buttons (Shop Pay, Apple Pay, Google Pay, PayPal) ---------- */
  /* Noah: express buttons in the cart like the best brands. Shopify's official cart buttons
     (content_for_additional_checkout_buttons, snippets/iyc-express.liquid) buy the real Shopify cart, so the
     order layer keeps the cart equal to the selection before anyone can tap them (iycInitOrder, xSync).
     IYC_X_REFRESH: after each cart write the buttons are fetched again (sections/iyc-express.liquid) so the
     wallets never start with an old cart. */
  var IYC_X_REFRESH = true;
  /* X1b 30.09.2026 (Noah: opening the order layer is no add to cart, it falsifies Meta and GA4).
     Shopify's web pixel manager wraps window.fetch and XMLHttpRequest and reports EVERY cart write that adds
     something (add.js, update.js, change.js, Storefront API) as product_added_to_cart -> Meta AddToCart,
     GA4 add_to_cart (read in /cdn/wpm/*.js, measured with x1_atc_quelle.py). The express buttons still need
     the selection in the real cart before anyone taps them, so this background write goes through the plain
     fetch of a hidden same-origin helper frame. The intent steps stay tracked: "Continue" writes the cart
     again through window.fetch (exactly one AddToCart), cart mode edits are real user actions.
     If the helper frame is unavailable, the normal fetch is used (cart stays right, AddToCart as before). */
  var iycQuietFrame = null;
  function iycQuietFetch() {
    try {
      if (!iycQuietFrame || !iycQuietFrame.isConnected) {
        iycQuietFrame = document.createElement('iframe');
        iycQuietFrame.setAttribute('aria-hidden', 'true');
        iycQuietFrame.setAttribute('tabindex', '-1');
        iycQuietFrame.title = 'cart';
        iycQuietFrame.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;visibility:hidden;';
        document.body.appendChild(iycQuietFrame);
      }
      var w = iycQuietFrame.contentWindow;
      // same origin check: reading the document of a foreign frame throws
      if (w && w.document && typeof w.fetch === 'function') return w.fetch.bind(w);
    } catch (e) {}
    return window.fetch.bind(window);
  }
  function iycQuietJson(url, body) {
    return iycQuietFetch()(location.origin + url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json && (json.description || json.message) ? json.description || json.message : 'Request failed');
        return json;
      });
    });
  }
  var iycX = {
    html: function () {
      // theme preview (unpublished copy): the Section Rendering API needs the theme id, else it renders the live theme
      var th = window.Shopify && window.Shopify.theme;
      var url = '/?sections=iyc-express' + (th && th.role && th.role !== 'main' && th.id ? '&preview_theme_id=' + th.id : '');
      // the answer depends on the cart (empty cart -> no buttons) but the browser caches it per URL: bust it
      url += '&iyc_x=' + Date.now();
      // no "Accept: application/json" header: with it Shopify renders the section without the buttons (measured 30.09.)
      return fetch(url, { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var d = new DOMParser().parseFromString((j && j['iyc-express']) || '', 'text/html');
          var slot = d.querySelector('[data-iyc-x-slot]');
          return slot ? slot.innerHTML : '';
        });
    },
    fill: function (box) {
      if (!box) return Promise.resolve();
      var slot = iycQ('[data-iyc-x-slot]', box);
      return iycX.html().then(function (h) {
        if (!h) { box.hidden = true; return; }
        // one set of buttons per page: an id="dynamic-checkout-cart" elsewhere is emptied first
        iycQA('[data-iyc-express] [data-iyc-x-slot]').forEach(function (o) { if (o !== slot) o.textContent = ''; });
        slot.innerHTML = h;
        box.hidden = false;
      });
    },
    lock: function (box, on) {
      if (!box) return;
      box.classList.toggle('iyc-xp-busy', Boolean(on));
      if (on) box.setAttribute('aria-busy', 'true'); else box.removeAttribute('aria-busy');
    },
    track: function (box, source) {
      if (!box || box.getAttribute('data-iyc-x-t')) return;
      box.setAttribute('data-iyc-x-t', '1');
      // clicks inside the closed shadow root arrive retargeted at the host element
      box.addEventListener('click', function () { iycTrack('express_checkout_click', { source: source() }); });
    },
  };

  function iycInitOrder(updateSticky) {
    var layer = document.getElementById('iyc-order');
    if (!layer) return;
    var hc = iycCfg.hardcover;
    var bundle = iycCfg.bundle;
    var ebook = iycCfg.ebook;
    var tiers = (iycCfg.tiers || []).slice().sort(function (a, b) { return a.books - b.books; });
    var rewardsOn = Boolean(iycCfg.rewards) && tiers.length > 0;
    var maxQty = Math.max(1, Number(iycCfg.maxQuantity) || 1000);
    var stepUpgrade = iycQ('[data-iyc-order-step="upgrade"]', layer);
    var stepReview = iycQ('[data-iyc-order-step="review"]', layer);
    var stepLabel = iycQ('[data-iyc-step-label]', layer);
    var list = document.getElementById('iyc-lines');
    var subtotal = document.getElementById('iyc-subtotal');
    var qty = document.getElementById('iyc-qty');
    var offer = document.getElementById('iyc-ebook-offer');
    var toggle = document.getElementById('iyc-ebook-toggle');
    var booksRow = document.getElementById('iyc-books-row');
    var booksTotal = document.getElementById('iyc-books-total');
    var button = document.getElementById('iyc-continue-checkout');
    var errorBox = document.getElementById('iyc-checkout-error');
    var crew = document.getElementById('iyc-crew');
    var ladder = document.getElementById('iyc-ladder');
    var more = document.getElementById('iyc-ladder-more');
    var msg = document.getElementById('iyc-crew-msg');
    var bar = document.getElementById('iyc-crew-bar');
    var notice = document.getElementById('iyc-upgrade-notice');
    var radios = iycQA('[data-iyc-edition-radio]', layer);
    /* W4 02.10.2026 (Noah): hardcover chosen -> offer the workbook in the eBook style; ticking it switches to the bundle. */
    var wbUp = document.getElementById('iyc-wb-upsell');
    var wbUpToggle = document.getElementById('iyc-wb-upsell-toggle');
    var wbUpUsed = false;
    /* E1 24.09.2026 (Noah: one cart, not four): the layer is the only cart. fromCart = opened with the
       real cart, so changes are written back to it; cart mode (#iyc-cartmode) shows carts the selection
       cannot model (team packs, both editions, other products) with the same look. */
    var fromCart = false;
    var startState = '';
    var cmBox = document.getElementById('iyc-cartmode');
    var cmList = document.getElementById('iyc-cm-lines');
    var cmSub = document.getElementById('iyc-cm-subtotal');
    var cmGo = document.getElementById('iyc-cm-go');
    var cmBusy = false;
    /* X1 30.09.2026: express buttons live under "Continue" (selection) and move under the cart-mode button. */
    var xBox = iycQ('[data-iyc-express]', layer);
    var xHome = xBox ? xBox.parentNode : null;
    var xSynced = null;   // state key that is in the Shopify cart right now
    var xTimer = 0;
    var xRun = null;      // running cart write
    var xSnap = null;     // opened fresh: our lines as they were before (restored when closed without checkout)
    /* W2/W3 02.10.2026 (Noah: the cart must open at once, the checkout faster): loudKey = selection the page wrote
       with window.fetch (one AddToCart already sent, e.g. the product page), xCart = cart answer of our last write,
       xAtc = AddToCart watch started when the product page opened the layer. */
    var loudKey = null;
    var xCart = null;
    var xAtc = null;

    var state = { selection: 'hardcover', qty: 1, ebook: false, decided: false };
    var opener = null;
    var expanded = false;
    var lastTier;

    if (!hc || !hc.id) return;
    var hasBundle = Boolean(bundle && bundle.id && bundle.available);
    var hasEbook = Boolean(ebook && ebook.id && ebook.available);
    if (!hasEbook && offer) offer.remove();
    if (!rewardsOn && crew) crew.remove();
    if (!hasBundle) iycQA('[data-iyc-order-goto="upgrade"]', layer).forEach(function (a) { a.hidden = true; });
    if (qty) qty.max = String(maxQty);
    if (wbUp && !hasBundle) wbUp.remove();
    /* UI-03-10: amount without "+" – it sits in the sentence "Add … for €15.00 more" */
    iycQA('[data-iyc-wb-diff]', layer).forEach(function (el) { if (hasBundle) el.textContent = iycFormatMoney(bundle.price - hc.price); });

    /* eBook weltweit 29.10.2026 (Noah: Kopf-Knopf „Currently unavailable“ in eBook-Ländern): Das Hardcover ist im eBook-Markt
       nicht verfügbar, der Kopf-Knopf führt dort aber zum eBook (snippets/iyc-ebook-kopf.liquid, Beschriftung „Get the eBook“).
       Deshalb nur außerhalb des eBook-Modus (RU/BY, übrige Sperren) als „nicht verfügbar“ markieren. */
    if (!hc.available && !(window.IYC_EB && window.IYC_EB.an)) {
      iycQA('[data-iyc-preorder]').forEach(function (a) {
        a.setAttribute('aria-disabled', 'true');
        a.classList.add('iyc-is-unavailable');
        a.textContent = T('Currently unavailable');
      });
    }

    function product(id) {
      return id === 'bundle' ? bundle : hc;
    }

    function tierStatus(books) {
      var tier = null;
      var next = null;
      tiers.forEach(function (t) {
        if (books >= t.books) tier = t;
        else if (!next) next = t;
      });
      var from = tier ? tier.books : 1;
      var progress = next ? Math.min(1, Math.max(0, (books - from) / (next.books - from))) : 1;
      return { tier: tier, next: next, toNext: next ? next.books - books : 0, progress: progress, free: tier ? tier.free : 0 };
    }

    function freeBooks() {
      return rewardsOn ? tierStatus(state.qty).free : 0;
    }

    function subtotalCents() {
      return product(state.selection).price * state.qty + (state.ebook && hasEbook ? ebook.price : 0);
    }

    /* eBook einzeln EE3110 (31.10.2026): was = durchgestrichener Einzelpreis vor dem Zeilenpreis (eBook als Zusatz) */
    function iycWas(p, was) {
      if (!was) return;
      var w = document.createElement('s');
      w.className = 'iyc-was';
      w.style.cssText = 'font-size:.85em;margin-right:.35em';
      w.textContent = was;
      p.insertBefore(w, p.firstChild);
    }

    function iycLine(key, title, detail, note, qtyN, priceText, small, removable, was) {
      var li = document.createElement('li');
      li.className = 'iyc-line' + (key === 'reward' ? ' iyc-reward' : '');
      li.setAttribute('data-iyc-key', key);
      var img = document.createElement('img');
      img.className = 'iyc-no-bw';
      var isBundleSel = (key === 'selection' && state.selection === 'bundle' && iycCfg.bundleImg);
      img.src = isBundleSel ? iycCfg.bundleImg : (iycCfg.coverImg || '');
      if (isBundleSel) { img.width = 480; img.height = 1383; li.classList.add('iyc-line-bundle'); }
      else { img.width = 240; img.height = 337; }
      img.alt = '';
      var t = document.createElement('div');
      t.className = 'iyc-t';
      var name = document.createElement('strong');
      name.textContent = qtyN > 1 || key === 'reward' ? qtyN + ' × ' + title : title;
      var d = document.createElement('span');
      d.textContent = detail;
      var n = document.createElement('span');
      n.textContent = note;
      t.appendChild(name);
      t.appendChild(d);
      t.appendChild(n);
      if (removable) {
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'iyc-link iyc-rm';
        rm.textContent = key === 'ebook' ? T('Remove eBook') : T('Remove');
        rm.setAttribute('aria-label', TF('Remove {title}', { title: title }));
        rm.addEventListener('click', function () {
          if (key === 'ebook') {
            state.ebook = false;
            iycTrack('remove_ebook', { source: 'line' });
            render();
            if (toggle) toggle.focus();
          } else if (fromCart) {
            // E1: opened with the real cart – Remove empties those lines in the cart, not just the view.
            iycTrack('remove_from_cart', { item_id: state.selection, source: 'cart' });
            rm.disabled = true;
            iycWriteCart(false).then(function () { fromCart = false; iycClose(); }, function () { fromCart = false; iycClose(); });
          } else {
            iycTrack('remove_from_cart', { item_id: state.selection });
            iycClose();
          }
        });
        t.appendChild(rm);
      }
      var p = document.createElement('div');
      p.className = 'iyc-p';
      p.textContent = priceText;
      iycWas(p, was);
      if (small) {
        var s = document.createElement('small');
        s.textContent = small;
        p.appendChild(s);
      }
      li.appendChild(img);
      li.appendChild(t);
      li.appendChild(p);
      return li;
    }

    function renderLines() {
      if (!list) return;
      list.textContent = '';
      var p = product(state.selection);
      var small = state.qty > 1 ? TF('{price} each', { price: iycFormatMoney(p.price) }) : p.later ? TF('{price} after the presale', { price: p.later }) : '';
      list.appendChild(iycLine('selection', p.title, p.detail, p.note, state.qty, iycFormatMoney(p.price * state.qty), small, true));
      var free = freeBooks();
      if (free > 0) {
        list.appendChild(iycLine('reward', free > 1 ? T('Free hardcovers – corner reward') : T('Free hardcover – corner reward'), T('Official hardcover, added to your order at no charge'), T('Ships with your order.'), free, T('Free'), TF('{price} value', { price: iycFormatMoney(hc.price * free) }), false));
      }
      if (state.ebook && hasEbook) {
        list.appendChild(iycLine('ebook', ebook.title, ebook.detail, ebook.note, 1, iycFormatMoney(ebook.price), ebook.later ? TF('{price} after the presale', { price: ebook.later }) : '', true,
          ebook.compare > ebook.price ? iycFormatMoney(ebook.compare) : ''));
      }
    }

    function iycIcon(id) {
      var tpl = document.getElementById(id);
      return tpl && tpl.content ? tpl.content.cloneNode(true) : document.createTextNode('');
    }

    function renderRewards() {
      if (!rewardsOn || !ladder || !msg || !bar) return;
      var books = state.qty;
      var v = tierStatus(books);
      if (lastTier !== undefined && v.tier && v.tier.name !== lastTier) {
        var prevTier = tiers.filter(function (t) { return t.name === lastTier; })[0];
        if (!prevTier || v.tier.books > prevTier.books) {
          crew.classList.remove('iyc-pop');
          void crew.offsetWidth;
          crew.classList.add('iyc-pop');
          iycTrack('volume_tier_unlocked', { tier: v.tier.name, quantity: books });
        }
      }
      lastTier = v.tier ? v.tier.name : null;
      var teaser = books < 5 && !expanded;
      bar.parentElement.hidden = teaser;
      crew.classList.toggle('iyc-is-teaser', teaser);
      var javierFrom = tiers.filter(function (t) { return t.javier; })[0];
      if (teaser) {
        msg.textContent = javierFrom ? TF('Ordering for a group? Free hardcovers from {a} books, Javier live from {b}.', { a: tiers[0].books, b: javierFrom.books }) : TF('Ordering for a group? Free hardcovers from {a} books.', { a: tiers[0].books });
      } else if (v.next) {
        var reward = TN(v.next.free, '{n} free hardcover', '{n} free hardcovers', null, !(v.next.free > 1)) + (v.next.javier ? T(' and a live session with Javier') : '');
        msg.textContent = (v.tier ? TF('{name} unlocked. ', { name: v.tier.name }) : '') + TN(v.toNext, 'Add {n} more book to unlock {reward}.', 'Add {n} more books to unlock {reward}.', { reward: reward }, !(v.toNext > 1));
      } else {
        msg.textContent = TF('{name} unlocked – the highest corner reward.', { name: v.tier.name });
      }
      bar.style.width = Math.round(v.progress * 100) + '%';

      ladder.textContent = '';
      var nextIndex = v.next ? tiers.indexOf(v.next) : tiers.length;
      var hidden = 0;
      tiers.forEach(function (t, i) {
        var li = document.createElement('li');
        var st = books >= t.books ? (v.tier && t.name === v.tier.name ? 'current' : 'done') : v.next && t.name === v.next.name ? 'next' : 'locked';
        li.setAttribute('data-iyc-state', st);
        if (teaser || (!expanded && st === 'locked' && i > nextIndex + 1)) {
          li.hidden = true;
          hidden++;
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-iyc-qty', String(t.books));
        b.setAttribute('aria-label', TN(t.books, 'Set quantity to {n} books ({name})', 'Set quantity to {n} books ({name})', { name: t.name }, true));
        b.setAttribute('aria-pressed', String(t.books === books));
        var ic = document.createElement('span');
        ic.className = 'iyc-ld-ic';
        ic.appendChild(iycIcon(st === 'locked' ? 'iyc-ic-lock' : st === 'next' ? 'iyc-ic-open' : 'iyc-ic-check'));
        var head = document.createElement('span');
        head.className = 'iyc-ld-head';
        var n = document.createElement('strong');
        n.textContent = TN(t.books, '{n} books', '{n} books', null, true);
        var nm = document.createElement('span');
        nm.className = 'iyc-ld-name';
        nm.textContent = t.name;
        head.appendChild(n);
        head.appendChild(nm);
        if (t.javier) {
          var badge = document.createElement('span');
          badge.className = 'iyc-ld-badge';
          badge.textContent = T('Javier live');
          head.appendChild(badge);
        }
        var gift = document.createElement('span');
        gift.className = 'iyc-ld-gift';
        gift.textContent = TN(t.free, '+{n} free', '+{n} free', null, true);
        b.appendChild(ic);
        b.appendChild(head);
        b.appendChild(gift);
        b.addEventListener('click', function () { setQty(t.books, 'ladder'); });
        li.appendChild(b);
        if (st === 'current' || st === 'next') {
          var perks = document.createElement('ul');
          perks.className = 'iyc-ld-perks';
          [TN(t.free, '{n} free official hardcover ({price} value)', '{n} free official hardcovers ({price} value)', { price: iycFormatMoney(t.free * hc.price) }, !(t.free > 1))].concat(t.perks.map(function (p) { return String(p).trim(); }).filter(Boolean)).forEach(function (text) {
            var pi = document.createElement('li');
            pi.textContent = text;
            perks.appendChild(pi);
          });
          li.appendChild(perks);
        }
        ladder.appendChild(li);
      });
      if (more) {
        more.hidden = hidden === 0 && !expanded;
        more.textContent = expanded ? T('Show fewer rewards') : teaser ? T('See the rewards') : TN(tiers[tiers.length - 1].free, 'Show all rewards – up to {n} free books', 'Show all rewards – up to {n} free books', null, true);
        more.setAttribute('aria-expanded', String(expanded));
      }
    }

    function render() {
      syncRadios();
      renderLines();
      if (wbUp && wbUp.isConnected) {
        /* UI-03-10: offer only with the hardcover; after the upgrade a confirmation without price, never "+€15" next to the bundle */
        var wbDrin = state.selection === 'bundle';
        wbUp.hidden = !(state.selection === 'hardcover' || (wbUpUsed && wbDrin));
        wbUp.classList.toggle('ist-drin', wbDrin);
      }
      if (offer) {
        offer.hidden = !hasEbook;
        if (toggle) toggle.checked = state.ebook;
      }
      if (qty && document.activeElement !== qty) qty.value = String(state.qty);
      var free = freeBooks();
      if (booksRow) booksRow.hidden = state.qty < 2 && free === 0;
      if (booksTotal) booksTotal.textContent = free ? TF('{a} paid + {b} free = {c}', { a: state.qty, b: free, c: state.qty + free }) : String(state.qty);
      if (subtotal) subtotal.textContent = iycFormatMoney(subtotalCents());
      /* Versand-Vorlage 08.10.2026: Balken bis zur Gratisversand-Grenze + Hinweise an Workbook-Upgrade und eBook
         (snippets/iyc-versand.liquid). Beide Wege laufen über die vorhandenen Karten (accept_bundle / add_ebook). */
      if (window.iycVs) window.iycVs(layer, subtotalCents(), {
        ort: 'ebene',
        ebook: hasEbook && !state.ebook, ebookPlus: hasEbook ? ebook.price : 0,
        bundle: hasBundle && state.selection === 'hardcover', bundlePlus: hasBundle ? (bundle.price - hc.price) * state.qty : 0
      });
      renderRewards();
      xSync();
    }

    /* X1 30.09.2026: the wallets buy the Shopify cart, so the selection is written to it right away (300 ms
       after the last change). While that runs the buttons are dimmed and cannot be tapped. */
    function xSync() {
      if (!xBox || !layer || layer.hidden || layer.classList.contains('iyc-cm-on') || busy) return;
      if (!xRun && iycStateKey() === xSynced) { iycX.lock(xBox, false); return; }
      iycX.lock(xBox, true);
      clearTimeout(xTimer);
      xTimer = setTimeout(xWrite, 300);
    }
    function xWrite() {
      if (xRun || busy) return;
      var key = iycStateKey();
      var first = !fromCart && xSnap === null;
      var ours = iycOurIds();
      xRun = (first ? iycQuietJson('/cart.js').then(function (cart) {
        xSnap = (cart.items || []).filter(function (it) { return ours.indexOf(it.variant_id) !== -1; })
          .map(function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }; });
      }) : Promise.resolve())
        .then(function () { return iycWriteCart(true, true); })
        .then(function () {
          xSynced = key;
          if (fromCart) startState = key;
          return IYC_X_REFRESH ? iycX.fill(xBox) : null;
        })
        .catch(function () { xSynced = null; })
        .then(function () {
          xRun = null;
          if (layer.hidden || busy) return;
          if (iycStateKey() === xSynced) iycX.lock(xBox, false); else xSync();
        });
    }
    /* Closed without checkout after opening fresh: the cart goes back to what it was (as before X1). */
    function xRestore() {
      var snap = xSnap;
      clearTimeout(xTimer);
      xSnap = null;
      if (snap === null || xSynced === null && !xRun) { xSynced = null; return; }
      xSynced = null;
      var ours = iycOurIds();
      (xRun || Promise.resolve())
        .then(function () { return iycQuietJson('/cart.js'); })
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (it) { if (ours.indexOf(it.variant_id) !== -1) updates[it.key] = 0; });
          return Object.keys(updates).length ? iycQuietJson('/cart/update.js', { updates: updates }) : null;
        })
        .then(function () { return snap.length ? iycQuietJson('/cart/add.js', { items: snap }) : null; })
        .then(function () { return iycQuietJson('/cart.js'); })
        .then(function (cart) { iycSetCount(cart.item_count); })
        .catch(function () {});
    }
    function xReset(synced) {
      clearTimeout(xTimer);
      xSnap = null;
      xSynced = synced || null;
      xCart = null;
      loudKey = null;
      xAtc = null;
    }
    /* Cart mode shows the real cart: buttons move under its checkout button, nothing to write. */
    function xPlace(cartMode) {
      if (!xBox || !xHome) return;
      var target = cartMode && cmGo ? cmGo.parentNode : xHome;
      if (xBox.parentNode !== target) {
        // X1b: moving rendered buttons re-runs shopify-paypal-button, which adds a SECOND PayPal frame next to the
        // first (measured: two 150 px frames overlapping in one slot). Empty the slot, move, load fresh.
        var sl0 = iycQ('[data-iyc-x-slot]', xBox);
        if (sl0) sl0.textContent = '';
        if (target === xHome) xHome.appendChild(xBox); else target.insertBefore(xBox, cmGo.nextSibling);
      }
      if (cartMode) { clearTimeout(xTimer); iycX.lock(xBox, false); } else xBox.hidden = false;
      // emptied while the fallback drawer had the buttons -> load them again
      var sl = iycQ('[data-iyc-x-slot]', xBox);
      if (sl && !sl.firstElementChild) iycX.fill(xBox).catch(function () {});
    }

    function setQty(n, source) {
      var before = state.qty;
      var v = Math.floor(Number(n));
      state.qty = isFinite(v) ? Math.min(maxQty, Math.max(1, v)) : 1;
      if (state.qty !== before) iycTrack('set_quantity', { quantity: state.qty, source: source });
      render();
    }

    function syncRadios() {
      radios.forEach(function (r) { r.checked = (r.value === state.selection); });
    }

    function showStep() {
      // Single-screen review: the edition switch lives inline, no separate upgrade step.
      if (stepUpgrade) stepUpgrade.hidden = true;
      if (stepReview) stepReview.hidden = false;
      if (stepLabel) stepLabel.textContent = T('Secure checkout');
      wbUpUsed = false;
      syncRadios();
      render();
      if (hasEbook) iycTrack('ebook_offer_shown', { branch: state.selection });
      var heading = iycQ('[data-iyc-order-step="review"] .iyc-flow-h', layer);
      if (heading) heading.setAttribute('tabindex', '-1');
      /* W2c 02.10.2026: scroll and focus after the first frame – each forced a full layout of the layer before it
         could paint (CPU profile, 4x throttled: 170 + 195 ms). */
      iycNachBild(function () {
        layer.scrollTop = 0;
        if (heading && !layer.hidden) heading.focus({ preventScroll: true });
      });
    }
    function iycNachBild(fn) {
      if (window.requestAnimationFrame) requestAnimationFrame(function () { setTimeout(fn, 0); }); else setTimeout(fn, 0);
    }
    /* "Your selection" below the layer's sticky bar when it sits low (mobile), as when opened from the cart icon */
    function iycZurAuswahl() {
      var ziel = [].slice.call(layer.querySelectorAll('[data-iyc-order-step="review"] h2')).filter(function (h) { return h.textContent.toLowerCase().indexOf(T('your selection').toLowerCase()) > -1; })[0];
      if (!ziel) return;
      iycNachBild(function () {
        var leiste = layer.querySelector('.iyc-order-bar');
        var oben = leiste ? leiste.getBoundingClientRect().bottom - layer.getBoundingClientRect().top : 0;
        var abstand = ziel.getBoundingClientRect().top - layer.getBoundingClientRect().top;
        if (abstand > layer.clientHeight * 0.45) layer.scrollTop = Math.max(0, abstand + layer.scrollTop - oben - 16);
      });
    }

    function iycOpen(source, pre) {
      opener = document.activeElement;
      fromCart = false;
      xReset();
      iycCartMode(false);
      /* A1b 23.09.2026: the order layer no longer has its own page view on the start page,
         so Clarity gets an explicit event (funnel "order opened"). */
      try { if (window.clarity) { window.clarity('event', 'order_open'); window.clarity('event', 'warenkorb_offen'); } } catch (e) {}
      state = { selection: 'hardcover', qty: 1, ebook: false, decided: false };
      expanded = false;
      lastTier = undefined;
      if (errorBox) errorBox.hidden = true;
      layer.hidden = false;
      root.classList.add('iyc-order-open');
      document.documentElement.classList.add('iyc-lock');
      if (updateSticky) updateSticky();
      iycTrack(source === 'sticky' ? 'sticky_cta_click' : 'click_preorder', { cta_id: source });
      // Always preselect the Complete Presale Bundle when it exists (best value).
      state.selection = hasBundle && pre !== 'hardcover' ? 'bundle' : 'hardcover';
      if (pre === 'ebook' && hasEbook) state.ebook = true;
      iycTrack('select_item', { item_id: state.selection });
      showStep();
    }

    /* E1 24.09.2026: switch the layer between the edition selection and the cart view. */
    function iycCartMode(on) {
      layer.classList.toggle('iyc-cm-on', Boolean(on));
      if (cmBox) cmBox.hidden = !on;
      xPlace(Boolean(on));
    }

    function iycSetCount(n) {
      var el = document.querySelector('[data-iyc-promo-n]');
      if (el) el.textContent = String(n || 0);
      iycQA('.v2c-cart-count').forEach(function (c) { c.textContent = '(' + (n || 0) + ')'; });
    }

    function iycOurIds() {
      return [hc && hc.id, bundle && bundle.id, ebook && ebook.id].filter(Boolean);
    }

    /* Replace this layer's own lines in the cart with the current selection (or remove them when
       keep === false). Everything else in the cart stays. Resolves with the new cart. */
    function iycWriteCart(keep, quiet) {
      var fj = quiet ? iycQuietJson : iycFetchJson;
      var main = product(state.selection);
      var free = freeBooks();
      var iycProps = function (p) { var o = { _campaign: 'in-your-corner-presale' }; if (p && p.later) o['After the presale'] = p.later; return o; };
      var items = [];
      if (keep !== false) {
        items.push({ id: main.id, quantity: state.qty, properties: iycProps(main) });
        if (free > 0) items.push({ id: hc.id, quantity: free, properties: { _volume_reward: 'free_hardcover' } });
        if (state.ebook && hasEbook) items.push({ id: ebook.id, quantity: 1, properties: iycProps(ebook) });
      }
      var ours = iycOurIds();
      return fj('/cart.js')
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (item) {
            if (ours.indexOf(item.variant_id) !== -1) updates[item.key] = 0;
          });
          return Object.keys(updates).length ? fj('/cart/update.js', { updates: updates }) : null;
        })
        .then(function () { return items.length ? fj('/cart/add.js', { items: items }) : null; })
        .then(function () { return fj('/cart.js'); })
        .then(function (cart) { iycSetCount(cart.item_count); xCart = keep !== false ? cart : null; return cart; });
    }

    function iycStateKey() {
      return JSON.stringify([state.selection, state.qty, state.ebook]);
    }

    /* ---- cart mode ---- */
    function iycCmLine(it) {
      var li = document.createElement('li');
      li.className = 'iyc-line iyc-cm-line';
      var img = document.createElement('img');
      img.className = 'iyc-no-bw';
      var isBundleLike = (bundle && it.variant_id === bundle.id) || /^team-pack-/.test(it.handle || '');
      img.src = isBundleLike && iycCfg.bundleImg ? iycCfg.bundleImg : (it.variant_id === (hc && hc.id) || !it.image ? iycCfg.coverImg || it.image : it.image);
      if (isBundleLike && iycCfg.bundleImg) { img.width = 480; img.height = 1383; li.classList.add('iyc-line-bundle'); }
      else { img.width = 240; img.height = 337; }
      img.alt = '';
      var t = document.createElement('div');
      t.className = 'iyc-t';
      var name = document.createElement('strong');
      name.textContent = it.product_title || it.title;
      t.appendChild(name);
      var detail = '';
      if (bundle && it.variant_id === bundle.id) detail = T('Hardcover + The Father’s Plan Workbook');
      else if (ebook && it.variant_id === ebook.id) detail = (ebook.note || T('Official digital edition'));
      else if (hc && it.variant_id === hc.id) detail = it.properties && it.properties._volume_reward ? T('Free hardcover – corner reward') : T((window.Shopify && window.Shopify.country === 'AE') ? 'Official hardcover, pre-order' : 'Official hardcover');
      else if (/^team-pack-/.test(it.handle || '')) detail = T('Hardcover + workbook for every member, shipped together');
      if (detail) { var d = document.createElement('span'); d.textContent = detail; t.appendChild(d); }
      var later = (it.properties && it.properties['After the presale']) || '';
      if (!later && bundle && it.variant_id === bundle.id) later = bundle.later || '';
      if (!later && ebook && it.variant_id === ebook.id) later = ebook.later || '';
      if (later) { var l = document.createElement('span'); l.textContent = TF('Presale price · {price} after the presale', { price: later }); t.appendChild(l); }
      var row = document.createElement('div');
      row.className = 'iyc-cm-row';
      var addon = ebook && it.variant_id === ebook.id;
      var reward = it.properties && it.properties._volume_reward;
      if (!addon && !reward) {
        var st = document.createElement('div');
        st.className = 'iyc-stepper iyc-cm-stepper';
        var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', T('One less'));
        var feld = document.createElement('input'); feld.type = 'number'; feld.inputMode = 'numeric'; feld.min = '1'; feld.max = String(maxQty); feld.value = String(it.quantity); feld.setAttribute('aria-label', T('Quantity'));
        var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', T('One more'));
        minus.disabled = it.quantity <= 1;
        plus.disabled = it.quantity >= maxQty;
        var setze = function (q) {
          q = Math.max(1, Math.min(maxQty, parseInt(q, 10) || 1));
          if (q === it.quantity) { feld.value = String(q); return; }
          iycTrack('cart_quantity_change', { item_id: it.variant_id, quantity: q });
          iycCmChange(it.key, q);
        };
        minus.addEventListener('click', function () { setze(it.quantity - 1); });
        plus.addEventListener('click', function () { setze(it.quantity + 1); });
        feld.addEventListener('change', function () { setze(feld.value); });
        st.appendChild(minus); st.appendChild(feld); st.appendChild(plus);
        row.appendChild(st);
      } else {
        var qn = document.createElement('span');
        qn.className = 'iyc-cm-qty';
        qn.textContent = TF('Qty {n}', { n: it.quantity });
        row.appendChild(qn);
      }
      if (!reward) {
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'iyc-link iyc-rm';
        rm.textContent = T('Remove');
        rm.setAttribute('aria-label', TF('Remove {title}', { title: it.product_title || it.title }));
        rm.addEventListener('click', function () {
          iycTrack('cart_remove', { item_id: it.variant_id });
          iycCmChange(it.key, 0);
        });
        row.appendChild(rm);
      }
      t.appendChild(row);
      var p = document.createElement('div');
      p.className = 'iyc-p';
      p.textContent = it.final_line_price ? iycFormatMoney(it.final_line_price) : T('Free');
      if (it.final_line_price && it.original_line_price > it.final_line_price) iycWas(p, iycFormatMoney(it.original_line_price));
      if (it.quantity > 1 && it.final_line_price) {
        var s = document.createElement('small');
        s.textContent = TF('{price} each', { price: iycFormatMoney(it.final_price) });
        p.appendChild(s);
      }
      li.appendChild(img);
      li.appendChild(t);
      li.appendChild(p);
      return li;
    }

    function iycCmRender(cart) {
      var items = (cart && cart.items) || [];
      iycSetCount(cart ? cart.item_count : 0);
      if (!items.length) {
        // Cart emptied: back to choosing an edition – the layer stays the one place to order.
        iycCartMode(false);
        state = { selection: hasBundle ? 'bundle' : 'hardcover', qty: 1, ebook: false, decided: false };
        showStep();
        return;
      }
      // A cart the selection can model again (e.g. team pack removed) goes back to the selection view.
      if (iycModel(cart)) {
        iycCartMode(false);
        state = iycModel(cart);
        fromCart = true;
        startState = iycStateKey();
        xReset(startState);
        showStep();
        return;
      }
      if (cmList) {
        cmList.textContent = '';
        items.forEach(function (it) { cmList.appendChild(iycCmLine(it)); });
      }
      if (cmSub) cmSub.textContent = iycFormatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      if (window.iycVs) window.iycVs(layer, cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price, { ort: 'korb' });
      var editions = items.some(function (it) { return it.variant_id === (hc && hc.id) || (bundle && it.variant_id === bundle.id); });
      layer.classList.toggle('iyc-cm-noextras', !editions);
      // "Add a single edition" only next to team packs etc. – with editions in the cart it would replace them.
      iycQA('[data-iyc-cm-edition]', layer).forEach(function (b) { b.parentNode.hidden = editions; });
      // eBook einzeln EE3110 (31.10.2026): das eBook ist überall auch allein kaufbar – Kasse immer offen
      if (cmGo) cmGo.hidden = false;
      if (xBox) xBox.hidden = false;
    }

    function iycCmChange(key, q) {
      if (cmBusy) return;
      cmBusy = true;
      if (cmBox) cmBox.setAttribute('aria-busy', 'true');
      iycFetchJson('/cart/change.js', { id: key, quantity: q })
        .then(function (cart) { cmBusy = false; if (cmBox) cmBox.removeAttribute('aria-busy'); iycCmRender(cart); if (IYC_X_REFRESH && xBox && !xBox.hidden && layer.classList.contains('iyc-cm-on')) iycX.fill(xBox).catch(function () {}); })
        .catch(function () {
          cmBusy = false;
          if (cmBox) cmBox.removeAttribute('aria-busy');
          iycFetchJson('/cart.js').then(iycCmRender).catch(function () {});
        });
    }

    function iycOpenCartMode(cart) {
      opener = document.activeElement;
      fromCart = false;
      xReset();
      try { if (window.clarity) window.clarity('event', 'cart_icon_open'); } catch (e) {}
      state = { selection: hasBundle ? 'bundle' : 'hardcover', qty: 1, ebook: false, decided: false };
      expanded = false;
      lastTier = undefined;
      if (errorBox) errorBox.hidden = true;
      layer.hidden = false;
      root.classList.add('iyc-order-open');
      document.documentElement.classList.add('iyc-lock');
      if (updateSticky) updateSticky();
      iycTrack('cart_icon_open', { mode: 'cart', items: (cart && cart.item_count) || 0 });
      iycCartMode(true);
      showStep();
      iycCmRender(cart);
      try { history.pushState({ iycOrder: 1 }, '', location.href); } catch (e) {}
    }
    if (cmGo) cmGo.addEventListener('click', function () { iycTrack('begin_checkout', { source: 'cart_mode' }); });
    iycQA('[data-iyc-cm-edition]', layer).forEach(function (b) {
      b.addEventListener('click', function () {
        // Add a single edition next to what is in the cart: the selection keeps all other lines.
        iycTrack('cart_mode_add_edition');
        iycCartMode(false);
        fromCart = false;
        xReset();
        state = { selection: hasBundle ? 'bundle' : 'hardcover', qty: 1, ebook: false, decided: false };
        showStep();
      });
    });

    function iycClose(fromHistory) {
      /* A1 23.09.2026: opened in-page with its own history entry -> step back through
         history, so the browser Back button and the X behave the same (popstate closes). */
      if (!fromHistory && history.state && history.state.iycOrder) { history.back(); return; }
      // E1: opened with the real cart – what was changed here stays in the cart (like any cart).
      if (fromCart && !busy && iycStateKey() !== startState) iycWriteCart(true).catch(function () {});
      // X1: opened fresh and written for the express buttons -> give the cart back as it was
      if (!fromCart && !busy) xRestore(); else xReset();
      fromCart = false;
      layer.hidden = true;
      root.classList.remove('iyc-order-open');
      document.documentElement.classList.remove('iyc-lock');
      if (updateSticky) updateSticky();
      if (opener && opener.focus) opener.focus({ preventScroll: true });
      iycOhneLandParam();
    }

    /* D1 24.09.2026: the cart icon opens this layer with the real cart – one place to order (Noah).
       The selection is taken from the cart (edition, quantity, eBook) and "Continue" replaces those lines,
       so nothing is added twice. Returns false when the layer cannot show the cart (team packs, both editions,
       other products, more than one eBook) – then the cart drawer opens instead. */
    // The selection this cart stands for, or null when the selection view cannot show it.
    function iycModel(cart) {
      if (!hc || !hc.available) return null;
      var items = (cart && cart.items) || [];
      var n = { hardcover: 0, bundle: 0, ebook: 0 };
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it.properties && it.properties._volume_reward) return null;
        if (it.variant_id === hc.id) n.hardcover += it.quantity;
        else if (bundle && it.variant_id === bundle.id) n.bundle += it.quantity;
        else if (ebook && it.variant_id === ebook.id) n.ebook += it.quantity;
        else return null;
      }
      if ((n.hardcover > 0) === (n.bundle > 0)) return null;
      if (n.ebook > 1 || (n.ebook && !hasEbook)) return null;
      var menge = n.bundle || n.hardcover;
      if (menge > maxQty) return null;
      return { selection: n.bundle > 0 ? 'bundle' : 'hardcover', qty: menge, ebook: n.ebook === 1, decided: true };
    }

    function iycOpenFromCart(cart) {
      var m = iycModel(cart);
      if (!m) return false;
      var sel = m.selection;
      var menge = m.qty;
      opener = document.activeElement;
      try { if (window.clarity) window.clarity('event', 'cart_icon_open'); } catch (e) {}
      state = m;
      fromCart = true;
      startState = iycStateKey();
      xReset(startState);
      iycCartMode(false);
      expanded = false;
      lastTier = undefined;
      if (errorBox) errorBox.hidden = true;
      layer.hidden = false;
      root.classList.add('iyc-order-open');
      document.documentElement.classList.add('iyc-lock');
      if (updateSticky) updateSticky();
      // Not click_preorder: that one counts as a conversion step in Google Ads.
      iycTrack('cart_icon_open', { item_id: sel, quantity: menge, ebook: state.ebook });
      showStep();
      try { history.pushState({ iycOrder: 1 }, '', location.href); } catch (e) {}
      var ziel = [].slice.call(layer.querySelectorAll('[data-iyc-order-step="review"] h2')).filter(function (h) { return h.textContent.toLowerCase().indexOf(T('your selection').toLowerCase()) > -1; })[0];
      if (ziel) {
        iycNachBild(function () {
          // below the layer's own sticky bar (logo, "Secure checkout", close), otherwise it covers the heading
          var leiste = layer.querySelector('.iyc-order-bar');
          var oben = leiste ? leiste.getBoundingClientRect().bottom - layer.getBoundingClientRect().top : 0;
          var abstand = ziel.getBoundingClientRect().top - layer.getBoundingClientRect().top;
          // Desktop: "Your selection" already sits in the upper half (second column) – do not cut the page heading off
          if (abstand > layer.clientHeight * 0.45) {
            layer.scrollTop = Math.max(0, abstand + layer.scrollTop - oben - 16);
          }
        });
      }
      return true;
    }

    /* W2 02.10.2026 (Noah: "It must open at once"): the product page knows the selection, so the layer opens with it
       right away instead of after cart.js -> add.js -> cart.js -> cart.js (measured 2.9-6.9 s on a slow phone).
       `writing` is the product page's cart write (window.fetch, so Shopify still reports one AddToCart); it runs as
       xRun: express buttons stay locked and "Continue" waits for it. When it worked, the cart holds exactly this
       selection (loudKey) and "Continue" goes straight to the checkout. */
    function iycOpenState(st, writing) {
      if (!hc.available) return false;
      var m = {
        selection: st && st.selection === 'bundle' && hasBundle ? 'bundle' : 'hardcover',
        qty: Math.min(maxQty, Math.max(1, parseInt(st && st.qty, 10) || 1)),
        ebook: Boolean(st && st.ebook) && hasEbook,
        decided: true,
      };
      opener = document.activeElement;
      try { if (window.clarity) window.clarity('event', 'cart_icon_open'); } catch (e) {}
      state = m;
      fromCart = true;
      startState = iycStateKey();
      xReset(null);
      var k0 = startState;
      xAtc = iycAtcWatch();
      if (writing && writing.then) {
        xRun = writing.then(function () {
          xSynced = k0;
          loudKey = k0;
          return IYC_X_REFRESH && xBox ? iycX.fill(xBox) : null;
        }, function () { xSynced = null; loudKey = null; })
          .catch(function () {})
          .then(function () {
            xRun = null;
            if (layer.hidden || busy) return;
            if (iycStateKey() === xSynced) iycX.lock(xBox, false); else xSync();
          });
      } else {
        xSynced = k0;
        loudKey = k0;
      }
      iycCartMode(false);
      expanded = false;
      lastTier = undefined;
      if (errorBox) errorBox.hidden = true;
      layer.hidden = false;
      root.classList.add('iyc-order-open');
      document.documentElement.classList.add('iyc-lock');
      if (updateSticky) updateSticky();
      iycTrack('cart_icon_open', { item_id: m.selection, quantity: m.qty, ebook: m.ebook, source: 'product_page' });
      showStep();
      iycZurAuswahl();
      try { history.pushState({ iycOrder: 1 }, '', location.href); } catch (e) {}
      return true;
    }

    iycQA('[data-iyc-preorder]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (!hc.available) return;
        // R4 30.09.2026: data-iyc-preset (hardcover|bundle|ebook) presets the edition, e.g. the header pill on the
        // hardcover product page opens the hardcover, not the bundle. Without it: bundle as before.
        iycOpen(a.getAttribute('data-iyc-preorder') || 'unknown', a.getAttribute('data-iyc-preset') || undefined);
      });
    });
    /* A1 23.09.2026: Pre-order links on this page open the order layer in place instead of
       loading /pages/pre-order. Going back from that page was a full reload (no bfcache:
       Shop Pay and web-pixel iframes), which flashed the page and could land at the top.
       Big shops do the same (overlay/drawer, Back closes it). Modified clicks (new tab)
       and the order page itself keep the normal link. */
    if (!document.getElementById('iyc-page-autofire')) {
      iycQA('a[href^="/pages/pre-order"]').forEach(function (a) {
        if (layer.contains(a) || a.hasAttribute('data-iyc-preorder')) return;
        a.addEventListener('click', function (ev) {
          if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
          if (!hc.available) return;
          ev.preventDefault();
          iycOpen(a.id || 'link');
          try { history.pushState({ iycOrder: 1 }, '', location.href); } catch (e) {}
        });
      });
      window.addEventListener('popstate', function () {
        if (!layer.hidden && !(history.state && history.state.iycOrder)) iycClose(true);
      });
    }
    iycQA('[data-iyc-order-close]', layer).forEach(function (el) {
      el.addEventListener('click', function (ev) { ev.preventDefault(); iycClose(); });
    });
    /* A1b 23.09.2026 (Clarity): 43 % of mobile dead taps hit the book image in the order
       line, on desktop the step rail looked clickable. The image now opens a large view,
       step 1 jumps to the edition switch, step 3 to the checkout button. */
    (function () {
      var zoom = document.createElement('div');
      zoom.className = 'iyc-zoom';
      zoom.hidden = true;
      zoom.setAttribute('role', 'dialog');
      zoom.setAttribute('aria-modal', 'true');
      zoom.setAttribute('aria-label', T('Book preview'));
      zoom.innerHTML = '<button type="button" class="iyc-zoom-x" aria-label="' + T('Close preview') + '">&times;</button><img alt="" />';
      layer.appendChild(zoom);
      var zImg = zoom.querySelector('img');
      var zBack = null;
      function zu() {
        if (zoom.hidden) return;
        zoom.classList.remove('iyc-zoom-on');
        setTimeout(function () { zoom.hidden = true; }, 200);
        if (zBack && zBack.focus) zBack.focus({ preventScroll: true });
      }
      zoom.addEventListener('click', zu);
      zoom.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') { ev.stopPropagation(); zu(); }
      });
      layer.addEventListener('click', function (ev) {
        var img = ev.target.closest && ev.target.closest('#iyc-lines .iyc-line img');
        if (!img || !img.src) return;
        zBack = img;
        zImg.src = img.src;
        zImg.alt = (img.closest('.iyc-line').querySelector('strong') || {}).textContent || 'In Your Corner';
        zoom.hidden = false;
        requestAnimationFrame(function () { zoom.classList.add('iyc-zoom-on'); });
        zoom.querySelector('.iyc-zoom-x').focus({ preventScroll: true });
        iycTrack('order_image_zoom');
      });
      var rail = iycQ('.iyc-rail', layer);
      if (rail) {
        var ziele = [iycQ('#iyc-edition-switch', layer) || iycQ('#iyc-lines', layer), null, iycQ('#iyc-continue-checkout', layer)];
        Array.prototype.forEach.call(rail.children, function (li, i) {
          var ziel = ziele[i];
          if (!ziel) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'iyc-rail-btn';
          while (li.firstChild) b.appendChild(li.firstChild);
          li.appendChild(b);
          b.addEventListener('click', function () {
            var cm = layer.classList.contains('iyc-cm-on');
            var z = cm ? (i === 2 ? cmGo : cmBox) || ziel : ziel;
            z.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (i === 2) setTimeout(function () { z.focus({ preventScroll: true }); }, 350);
          });
        });
      }
    })();
    iycQA('[data-iyc-order-goto="upgrade"]', layer).forEach(function (el) {
      el.addEventListener('click', function (ev) { ev.preventDefault(); showStep('upgrade'); });
    });
    iycQA('[data-iyc-choice]', layer).forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        state.selection = a.getAttribute('data-iyc-choice') === 'bundle' ? 'bundle' : 'hardcover';
        state.decided = true;
        iycTrack(state.selection === 'bundle' ? 'accept_bundle' : 'decline_bundle');
        showStep('review');
      });
    });
    layer.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') iycClose();
    });
    if (wbUpToggle) {
      /* UI-03-10: one-way upgrade button (no checkbox); back to the hardcover only via the edition choice above */
      wbUpToggle.addEventListener('click', function () {
        if (!hasBundle || state.selection === 'bundle') return;
        wbUpUsed = true;
        state.selection = 'bundle';
        state.decided = true;
        iycTrack('accept_bundle', { source: 'cart_upsell' });
        render();
        var ok = wbUp.querySelector('.iyc-wb-up-ok');
        if (ok) { try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); } }
      });
    }
    if (toggle) {
      toggle.addEventListener('change', function () {
        state.ebook = toggle.checked && hasEbook;
        iycTrack(state.ebook ? 'add_ebook' : 'remove_ebook', { source: 'checkbox' });
        render();
      });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        state.selection = r.value === 'bundle' ? 'bundle' : 'hardcover';
        state.decided = true;
        iycTrack(state.selection === 'bundle' ? 'accept_bundle' : 'decline_bundle', { source: 'switch' });
        render();
      });
    });
    iycQA('[data-iyc-step]', layer).forEach(function (b) {
      b.addEventListener('click', function () { setQty(state.qty + Number(b.getAttribute('data-iyc-step')), 'stepper'); });
    });
    if (qty) {
      qty.addEventListener('change', function () { setQty(qty.value, 'input'); });
      qty.addEventListener('blur', function () { qty.value = String(state.qty); });
    }
    if (more) {
      more.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }

    function iycFetchJson(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json && (json.description || json.message) ? json.description || json.message : 'Request failed');
          return json;
        });
      });
    }

    /* P9 29.09.2026: Meta's AddToCart is sent by the Facebook & Instagram app pixel a few dozen ms after
       /cart/add.js answers (Shopify standard event product_added_to_cart). Leaving for /checkout right
       away cut that request off on slower phones (6x CPU: 3 of 4 lost), while the checkout still counted
       InitiateCheckout. Watch the resource timing from the click on and leave as soon as the pixel request
       has finished, at most IYC_ATC_WAIT ms after the cart answered. No marketing consent: no wait. */
    var IYC_ATC_WAIT = 400;
    function iycAtcWatch() {
      var since = window.performance && performance.now ? performance.now() : 0;
      var hit = false;
      var done = null;
      var obs = null;
      function isAtc(list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].startTime >= since && /facebook\.com\/tr\/?\?[^#]*\bev=AddToCart\b/.test(list[i].name)) return true;
        }
        return false;
      }
      function mark() { hit = true; if (obs) { try { obs.disconnect(); } catch (e) {} } if (done) done(); }
      try {
        obs = new PerformanceObserver(function (l) { if (isAtc(l.getEntries())) mark(); });
        obs.observe({ type: 'resource' });
      } catch (e) { obs = null; }
      return function wait() {
        return new Promise(function (resolve) {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          var noMarketing = false;
          try { noMarketing = !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false); } catch (e) {}
          if (!hit && !noMarketing && !obs && performance.getEntriesByType) hit = isAtc(performance.getEntriesByType('resource'));
          if (hit || noMarketing) { if (obs) { try { obs.disconnect(); } catch (e) {} } resolve(); return; }
          var timer = setTimeout(function () { if (obs) { try { obs.disconnect(); } catch (e) {} } resolve(); }, obs ? IYC_ATC_WAIT : 250);
          done = function () { clearTimeout(timer); resolve(); };
        });
      };
    }

    var busy = false;
    if (button) {
      button.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        var atcWait = iycAtcWatch();
        if (errorBox) errorBox.hidden = true;
        button.setAttribute('aria-busy', 'true');
        var label = iycQ('span', button);
        var original = label ? label.textContent : '';
        if (label) label.textContent = T('Preparing secure checkout…');
        var main = product(state.selection);
        var free = freeBooks();
        var ours = [hc.id, bundle && bundle.id, ebook && ebook.id].filter(Boolean);
        // H1 23.09.2026: visible line item property carries the later price into cart and checkout (plain text, no strike price).
        var iycProps = function (p) { var o = { _campaign: 'in-your-corner-presale' }; if (p && p.later) o['After the presale'] = p.later; return o; };
        var items = [{ id: main.id, quantity: state.qty, properties: iycProps(main) }];
        if (free > 0) items.push({ id: hc.id, quantity: free, properties: { _volume_reward: 'free_hardcover' } });
        if (state.ebook && hasEbook) items.push({ id: ebook.id, quantity: 1, properties: iycProps(ebook) });
        var key = iycStateKey();

        // X1b: the express sync writes quietly (no AddToCart when only opening). "Continue" is the intent:
        // wait for a running sync, then write the selection through window.fetch -> exactly one AddToCart.
        clearTimeout(xTimer);
        // Replace earlier selections of these products, keep everything else in the cart.
        // W3 02.10.2026: the cart answer of our own last write (xCart) replaces the first /cart.js; if it is
        // stale, update.js fails and the write runs once more with a fresh cart.
        function write(cartNow) {
          return (cartNow ? Promise.resolve(cartNow) : iycFetchJson('/cart.js'))
            .then(function (cart) {
              var updates = {};
              (cart.items || []).forEach(function (item) {
                if (ours.indexOf(item.variant_id) !== -1) updates[item.key] = 0;
              });
              return Object.keys(updates).length ? iycFetchJson('/cart/update.js', { updates: updates }) : null;
            })
            .then(function () { return iycFetchJson('/cart/add.js', { items: items }); });
        }
        var how = 'write';
        ((xRun || Promise.resolve()).then(function () {
          // W3: the product page already wrote exactly this selection (with its AddToCart): straight to the checkout.
          if (loudKey !== null && key === loudKey && xSynced === key && free === 0) { how = 'ready'; return null; }
          var known = xCart && xSynced === key ? xCart : null;
          return write(known).catch(function (err) { if (!known) throw err; return write(null); });
        }))
          .then(function () {
            iycTrack('begin_checkout', { value: subtotalCents() / 100, currency: iycCfg.currency || '', quantity: state.qty, cart: how });
            // P9: the cart is written; give the AddToCart pixel its moment (≤ 400 ms), then go.
            var w = how === 'ready' ? (xAtc || function () { return Promise.resolve(); }) : atcWait;
            return w().then(function () { window.location.assign('/checkout'); });
          })
          .catch(function (err) {
            iycTrack('checkout_error', { error_code: 'cart' });
            how = 'error';
            if (errorBox) {
              errorBox.textContent = (err && err.message ? err.message + ' ' : '') + T('Please try again.');
              errorBox.hidden = false;
              errorBox.focus();
            }
            busy = false;
            button.removeAttribute('aria-busy');
            if (label) label.textContent = original;
          });
      });
    }

    if (button) {
      // W3: view_cart after the cart requests have started (the click handler above runs first)
      button.addEventListener('click', function () {
        setTimeout(function () { iycTrack('view_cart', { value: subtotalCents() / 100 }); }, 0);
      });
    }
    iycX.track(xBox, function () { return layer.classList.contains('iyc-cm-on') ? 'cart_mode' : (fromCart ? 'cart' : 'selection'); });

    /* KL1 05.10.2026 (Noah: stay in the layer when the country changes, no reload – euro/dollar prices and shipping
       switch in place). The chooser under the shipping line (snippets/iyc-land-wahl.liquid, ort 'korb') is Shopify's
       localization form. Sent with fetch (redirect not followed – the answer only sets the cookies localization and
       cart_currency; Shopify reprices the same cart, measured: cart.js EUR -> USD, same lines). Then the start page is
       fetched in the new market: its #iyc-config gives the prices (merged into the objects this layer already holds),
       its #iyc-order the static texts of the layer, and – on other pages – the current page the texts behind the layer
       (product page: #iyc-pdp-daten + event iyc:land, sections/iyc-product.liquid redraws its prices).
       Our lines in the cart are written again quietly (no AddToCart: helper frame) so their "After the presale"
       price is in the new currency; the express buttons are fetched again. No new click/cart events: the visitor
       only changed the country (one country_switch event). If anything fails, the form is sent the normal way
       and the page comes back with the cart open (?iyc_cart=1, as from /cart). */
    var landLauf = null;
    var landNeu = false;   // switched in this page view: keep ?country=XX out of every history entry we come back to
    function iycOhneLandParam() {
      if (!landNeu) return;
      try {
        var u = new URL(location.href);
        if (u.searchParams.has('country')) { u.searchParams.delete('country'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); }
      } catch (e) {}
    }
    function iycLandSchicken(form, code) {
      try {
        Array.prototype.forEach.call(form.querySelectorAll('input[name=return_to]'), function (r) {
          r.value = location.pathname + '?iyc_cart=1';
        });
        var f = form.querySelector('input[name=country_code]');
        if (!f) { f = document.createElement('input'); f.type = 'hidden'; f.name = 'country_code'; form.appendChild(f); }
        f.value = code;
        form.setAttribute('data-iyc-nativ', '1');
        HTMLFormElement.prototype.submit.call(form);
      } catch (e) {}
    }
    function iycLandWechsel(form, code) {
      if (landLauf || !/^[A-Z]{2}$/.test(code || '')) return landLauf;
      var html = document.documentElement;
      var vorher = (window.Shopify && window.Shopify.country) || '';
      var pfad = location.pathname;
      var start = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
      var th = window.Shopify && window.Shopify.theme;
      var vorschau = th && th.role && th.role !== 'main' && th.id ? 'preview_theme_id=' + th.id : '';
      function adresse(p) {
        var q = [];
        try {
          var u = new URL(p, location.origin);
          u.searchParams.forEach(function (v, k) { if (!/^(country|iyc_cart|iyc_order|preview_theme_id)$/.test(k)) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
          p = u.pathname;
        } catch (e) {}
        if (vorschau) q.push(vorschau);
        q.push('iyc_land=' + Date.now());
        return p + '?' + q.join('&');
      }
      // P1 (snippets/iyc-kopf-rechts.liquid): Shopify sometimes answers a fetch with 429 "Verifying your connection" –
      // try twice more before falling back to the page load
      function seite(p, versuch) {
        versuch = versuch || 0;
        return fetch(adresse(p), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (t) { return { doc: new DOMParser().parseFromString(t, 'text/html'), roh: t }; })
          .catch(function (err) {
            if (versuch >= 2) throw err;
            return new Promise(function (ok) { setTimeout(ok, versuch ? 2200 : 700); }).then(function () { return seite(p, versuch + 1); });
          });
      }
      layer.classList.add('iyc-land-busy');
      layer.setAttribute('aria-busy', 'true');
      clearTimeout(xTimer);
      var geldVorher = iycCfg.currency;
      if (xBox && !layer.classList.contains('iyc-cm-on')) iycX.lock(xBox, true);
      var fd = new FormData(form);
      fd.set('country_code', code);
      fd.set('return_to', '/cart.js');
      var istStart = pfad === start || pfad + '/' === start;
      landLauf = (xRun || Promise.resolve()).catch(function () {})
        .then(function () { return fetch(form.getAttribute('action') || '/localization', { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'manual' }); })
        .then(function (r) { if (!(r.type === 'opaqueredirect' || r.ok)) throw new Error('localization ' + r.status); })
        .then(function () { return Promise.all([seite(start), istStart ? null : seite(pfad + location.search)]); })
        .then(function (s) {
          var ds = s[0].doc;
          var dp = s[1] ? s[1].doc : ds;
          var cfgNeu = ds.getElementById('iyc-config');
          var ebeneNeu = ds.getElementById('iyc-order');
          if (!cfgNeu || !ebeneNeu) throw new Error('layer missing');
          var neu = JSON.parse(cfgNeu.textContent || '{}');
          if (neu.currency && iycCfg.currency && neu.currency === iycCfg.currency && vorher && vorher !== code &&
              (['DE', 'AT'].indexOf(vorher) > -1) !== (['DE', 'AT'].indexOf(code) > -1)) throw new Error('market unchanged');
          // prices: merge into the objects this layer holds (hc, bundle, ebook are references into iycCfg)
          Object.keys(neu).forEach(function (k) {
            var a = iycCfg[k], b = neu[k];
            if (a && b && typeof a === 'object' && typeof b === 'object' && !Array.isArray(a) && !Array.isArray(b)) {
              Object.keys(b).forEach(function (kk) { a[kk] = b[kk]; });
            } else iycCfg[k] = b;
          });
          var cfgEl2 = document.getElementById('iyc-config');
          if (cfgEl2) cfgEl2.textContent = cfgNeu.textContent;
          if (neu.currency !== geldVorher) {
            iycPaypalWeg();
            // express buttons of the page behind (product page buy box) are rendered for one currency: take the new ones
            var xpNeu = dp.querySelectorAll('shopify-accelerated-checkout');
            Array.prototype.forEach.call(document.querySelectorAll('shopify-accelerated-checkout'), function (x, i) {
              if (!layer.contains(x) && xpNeu[i]) x.parentNode.replaceChild(document.importNode(xpNeu[i], true), x);
            });
          }
          var stat = { texts: 0, blocks: 0, offen: [] };
          iycAbgleich(layer, ebeneNeu, stat);
          iycTausche('.iyc-lwk', layer, ebeneNeu);
          // the page behind the layer: every section that exists in both, and the country chooser in the footer
          Array.prototype.forEach.call(document.querySelectorAll('[id^="shopify-section-"]'), function (sec) {
            var gegen = dp.getElementById(sec.id);
            if (gegen) iycAbgleich(sec, gegen, stat);
          });
          Array.prototype.forEach.call(document.querySelectorAll('.iyc-lw'), function (a) {
            if (layer.contains(a)) return;
            var n = dp.querySelectorAll('.iyc-lw')[0];
            if (n) a.parentNode.replaceChild(document.importNode(n, true), a);
          });
          // data islands of the page (product page prices) – the page's own script redraws on iyc:land
          Array.prototype.forEach.call(dp.querySelectorAll('script[type="application/json"][id]'), function (n) {
            if (n.id === 'iyc-config') return;
            var a = document.getElementById(n.id);
            if (a && a.textContent !== n.textContent) a.textContent = n.textContent;
          });
          // Shopify globals for later scripts (apps, pixels read them)
          try {
            var m = /Shopify\.currency\s*=\s*(\{[^}]*\})/.exec(s[0].roh);
            if (window.Shopify) {
              window.Shopify.country = code;
              if (m) window.Shopify.currency = JSON.parse(m[1]);
            }
          } catch (e) {}
          // P1c: "ships worldwide" lines only for visitors from elsewhere in the US/CA market
          var echt = html.getAttribute('data-iyc-land') || '';
          if (/^[A-Z]{2}$/.test(echt)) html.classList.toggle('iyc-welt', ['US', 'DE', 'AT'].indexOf(echt) < 0 && (code === 'US' || code === 'CA'));
          // address without ?country=XX, so a reload stays in the new market (history entry kept; iycClose cleans
          // the entry below the layer too)
          landNeu = true;
          iycOhneLandParam();
          window.iycLandStat = stat;
          // redraw the layer with the new prices – silently
          iycRuhig = true;
          try {
            iycQA('[data-iyc-wb-diff]', layer).forEach(function (el) { if (hasBundle) el.textContent = iycFormatMoney(bundle.price - hc.price); });
            if (!layer.classList.contains('iyc-cm-on')) render();
          } finally { iycRuhig = false; }
          try { document.dispatchEvent(new CustomEvent('iyc:land', { detail: { country: code, currency: iycCfg.currency, muster: iycFormatMoney(123456).replace(/<[^>]*>/g, '') } })); } catch (e) {}
          return iycQuietJson('/cart.js');
        })
        .then(function (cart) {
          iycRuhig = true;
          try {
            if (layer.classList.contains('iyc-cm-on')) {
              iycCmRender(cart);
              if (xBox && !xBox.hidden) iycX.fill(xBox).catch(function () {});
            } else if (xSynced !== null && !busy) {
              // our lines are in the cart: write them again quietly ("After the presale" in the new currency);
              // xWrite fetches the express buttons again when done (otherwise render() -> xSync does both)
              xSynced = null;
              xWrite();
            }
          } finally { iycRuhig = false; }
          iycTrack('country_switch', { country: code, from: vorher, currency: (cart && cart.currency) || iycCfg.currency || '', source: 'cart' });
          var s = iycQA('.iyc-lwk-s', layer).filter(function (el) { return el.offsetParent; })[0];
          if (s) { try { s.focus({ preventScroll: true }); } catch (e) {} }
        })
        .catch(function (err) {
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'country_switch_error', page: location.pathname, error: String(err && err.message || err).slice(0, 80) }); } catch (e) {}
          try { if (window.console) console.warn('iyc country switch: page load fallback', err); } catch (e) {}
          iycLandSchicken(form, code);
        })
        .then(function () {
          landLauf = null;
          layer.classList.remove('iyc-land-busy');
          layer.removeAttribute('aria-busy');
        });
      return landLauf;
    }

    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted && button) {
        busy = false;
        button.removeAttribute('aria-busy');
      }
    });
    return {
      openFromCart: iycOpenFromCart,
      openCartMode: iycOpenCartMode,
      openState: iycOpenState,
      land: iycLandWechsel,
      // Product pages and /cart land here: ?iyc_order=bundle|hardcover|ebook opens the selection preset.
      openPreset: function (pre, source) {
        if (!hc.available) return;
        iycOpen(source || 'product_page', pre);
        try { history.pushState({ iycOrder: 1 }, '', location.href); } catch (e) {}
      },
    };
  }

  /* ---------- trailer (optional) ---------- */
  function iycInitTrailer() {
    var v = iycQ('.iyc-trailer video');
    if (v) v.addEventListener('play', function () { iycTrack('trailer_play'); }, { once: true });
  }

  /* ---------- right-side cart drawer (replaces navigating to /cart) ---------- */
  /* D1 24.09.2026: the cart icon opens the order layer with the real cart (one place to order – Noah).
     Only when the layer cannot show the cart (team packs, both editions, other products) this drawer opens:
     quantity steppers (Ajax /cart/change.js), summary with free shipping, total on the checkout button,
     promises and trust row from snippets/iyc-cart-extras.liquid (same source as /cart). No upsells here –
     they live in the order layer. eBook-only carts stay locked. The sticky bar hides while it is open. */
  var iycCartDrawerApi = {};
  function iycInitCartDrawer(updateSticky, order) {
    var layer = document.getElementById('iyc-cart');
    if (!layer) return;
    var itemsEl = document.getElementById('iyc-cart-items');
    var emptyEl = document.getElementById('iyc-cart-empty');
    var footEl = document.getElementById('iyc-cart-foot');
    var subEl = document.getElementById('iyc-cart-subtotal');
    var infoEl = document.getElementById('iyc-cart-info');
    var extrasEl = layer.querySelector('[data-iyc-ce-extras]');
    var totalEl = layer.querySelector('[data-iyc-cart-total]');
    var counts = iycQA('.v2c-cart-count');
    var opener = null;
    var busy = false;
    var MAXQ = Math.max(1, Number(iycCfg.maxQuantity) || 1000);
    var hcId = iycCfg.hardcover && iycCfg.hardcover.id;
    var bundleId = iycCfg.bundle && iycCfg.bundle.id;
    var ebookId = iycCfg.ebook && iycCfg.ebook.id;
    var IYC_ADDON_HANDLES = ['in-your-corner-official-ebook'];

    function fetchJson(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json && (json.description || json.message) ? json.description || json.message : 'Request failed');
          return json;
        });
      });
    }
    function setCount(n) {
      counts.forEach(function (c) { c.textContent = '(' + n + ')'; });
    }
    // H1 23.09.2026: price after the presale under bundle and eBook lines (plain text).
    function iycCartLater(mid, it) {
      var later = (it.properties && it.properties['After the presale']) || '';
      if (!later && iycCfg.bundle && it.variant_id === iycCfg.bundle.id) later = iycCfg.bundle.later || '';
      if (!later && iycCfg.ebook && it.variant_id === iycCfg.ebook.id) later = iycCfg.ebook.later || '';
      if (!later) return;
      var s = document.createElement('span'); s.className = 'iyc-cart-later';
      s.textContent = TF('Presale price · {price} after the presale', { price: later });
      mid.appendChild(s);
    }
    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }
    // One action at a time; every change re-renders from the cart Shopify returns.
    function run(p, knopf) {
      if (busy) return;
      busy = true;
      layer.setAttribute('aria-busy', 'true');
      if (knopf) knopf.disabled = true;
      p().then(function () { return fetchJson('/cart.js'); })
        .then(function (cart) { busy = false; layer.removeAttribute('aria-busy'); render(cart); })
        .catch(function () {
          busy = false; layer.removeAttribute('aria-busy');
          if (knopf) knopf.disabled = false;
          fetchJson('/cart.js').then(render).catch(function () {});
        });
    }
    function detail(it) {
      if (bundleId && it.variant_id === bundleId) return 'Hardcover + The Father’s Plan Workbook';
      if (ebookId && it.variant_id === ebookId) return iycCfg.ebook.note || 'Official digital edition';
      if (hcId && it.variant_id === hcId) return (window.Shopify && window.Shopify.country === 'AE') ? 'Official hardcover, pre-order' : 'Official hardcover';
      return it.variant_title || '';
    }

    function renderLine(it) {
      var li = el('li', 'iyc-cart-item');
      var img = document.createElement('img'); img.src = it.image || iycCfg.coverImg || ''; img.alt = ''; img.width = 56; img.height = 76; img.loading = 'lazy';
      var mid = el('div', 'iyc-cart-it-mid');
      mid.appendChild(el('strong', '', it.product_title || it.title));
      var d = detail(it);
      if (d) mid.appendChild(el('span', 'iyc-cart-detail', d));
      iycCartLater(mid, it);
      var reihe = el('div', 'iyc-cart-row');
      if (IYC_ADDON_HANDLES.indexOf(it.handle) === -1) {
        var stepper = el('div', 'iyc-cart-stepper');
        var minus = el('button', 'iyc-cart-step', '−'); minus.type = 'button'; minus.setAttribute('data-iyc-step', '-1'); minus.setAttribute('aria-label', T('One less'));
        var feld = document.createElement('input'); feld.type = 'text'; feld.inputMode = 'numeric'; feld.value = String(it.quantity); feld.setAttribute('data-iyc-qty', ''); feld.setAttribute('aria-label', T('Quantity'));
        var plus = el('button', 'iyc-cart-step', '+'); plus.type = 'button'; plus.setAttribute('data-iyc-step', '1'); plus.setAttribute('aria-label', T('One more'));
        minus.disabled = it.quantity <= 1;
        plus.disabled = it.quantity >= MAXQ;
        var setze = function (q, knopf) {
          q = Math.max(1, Math.min(MAXQ, parseInt(q, 10) || 1));
          if (q === it.quantity) { feld.value = String(q); return; }
          iycTrack('cart_quantity_change', { item_id: it.variant_id, quantity: q });
          run(function () { return fetchJson('/cart/change.js', { id: it.key, quantity: q }); }, knopf);
        };
        minus.addEventListener('click', function () { setze(it.quantity - 1, minus); });
        plus.addEventListener('click', function () { setze(it.quantity + 1, plus); });
        feld.addEventListener('change', function () { setze(feld.value, null); });
        stepper.appendChild(minus); stepper.appendChild(feld); stepper.appendChild(plus);
        reihe.appendChild(stepper);
      } else {
        reihe.appendChild(el('span', 'iyc-cart-qty', 'Qty ' + it.quantity));
      }
      var rm = el('button', 'iyc-cart-rm', 'Remove'); rm.type = 'button';
      rm.addEventListener('click', function () {
        iycTrack('cart_remove', { item_id: it.variant_id });
        run(function () { return fetchJson('/cart/change.js', { id: it.key, quantity: 0 }); }, rm);
      });
      reihe.appendChild(rm);
      mid.appendChild(reihe);
      var preis = el('span', 'iyc-cart-price', iycFormatMoney(it.final_line_price));
      if (it.original_line_price > it.final_line_price) {   // EE3110: Zusatz-Rabatt „eBook with your book“ sichtbar
        var alt = el('s', 'iyc-was', iycFormatMoney(it.original_line_price));
        alt.style.cssText = 'font-size:.85em;margin-right:.35em';
        preis.insertBefore(alt, preis.firstChild);
      }
      li.appendChild(img); li.appendChild(mid); li.appendChild(preis);
      return li;
    }

    function render(cart) {
      if (!cart || !itemsEl) return;
      itemsEl.textContent = '';
      var items = cart.items || [];
      setCount(cart.item_count || 0);
      if (!items.length) {
        if (emptyEl) emptyEl.hidden = false;
        if (footEl) footEl.hidden = true;
        if (infoEl) infoEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.hidden = false;
      if (infoEl) infoEl.hidden = false;
      items.forEach(function (it) { itemsEl.appendChild(renderLine(it)); });
      // Presale exclusives belong to the editions (hardcover, bundle) – not claimed for team packs or the eBook alone.
      if (extrasEl) extrasEl.hidden = !items.some(function (it) { return it.variant_id === hcId || it.variant_id === bundleId; });
      if (subEl) subEl.textContent = iycFormatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      if (totalEl) totalEl.textContent = iycFormatMoney(cart.total_price);

      // eBook einzeln EE3110 (31.10.2026): das eBook ist überall auch allein kaufbar – keine Sperre mehr vor der Kasse.
      // X1 30.09.2026: express buttons under the checkout button (loaded when this drawer shows a cart)
      var xb = iycQ('[data-iyc-express]', layer);
      if (xb) {
        iycX.track(xb, function () { return 'cart_drawer'; });
        iycX.fill(xb).catch(function () { xb.hidden = true; });
      }
    }

    function open(cart) {
      opener = document.activeElement;
      layer.hidden = false;
      document.documentElement.classList.add('iyc-lock');
      root.classList.add('iyc-cart-open');
      if (updateSticky) updateSticky();
      iycTrack('view_cart_drawer');
      if (cart) render(cart); else fetchJson('/cart.js').then(render).catch(function () {});
      var x = iycQ('[data-iyc-cart-close]', layer);
      if (x) x.focus();
    }
    function close() {
      layer.hidden = true;
      document.documentElement.classList.remove('iyc-lock');
      root.classList.remove('iyc-cart-open');
      if (updateSticky) updateSticky();
      if (opener && opener.focus) opener.focus();
    }
    /* E1 24.09.2026: the cart icon (and /cart, the checkout's cart link, product pages) always opens the
       order layer – as the editable selection, or in cart mode for team packs and mixed carts. The side
       drawer stays only as a last resort when the layer is missing. Empty cart: choose an edition. */
    function viaSymbol() {
      fetchJson('/cart.js').then(function (cart) {
        if (order && order.openFromCart && order.openFromCart(cart)) return;
        if (order && order.openCartMode && cart && cart.item_count > 0) { order.openCartMode(cart); return; }
        if (order && order.openPreset) { order.openPreset('', 'cart_empty'); return; }
        open(cart);
      }).catch(function () { open(null); });
    }
    iycCartDrawerApi.open = viaSymbol;

    iycQA('[data-iyc-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); viaSymbol(); });
    });
    iycQA('[data-iyc-cart-close]', layer).forEach(function (el) {
      el.addEventListener('click', function () { close(); });
    });
    var goBtn = document.getElementById('iyc-cart-checkout');
    if (goBtn) goBtn.addEventListener('click', function () { iycTrack('begin_checkout', { source: 'cart_drawer' }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !layer.hidden) close(); });
  }

  iycTrack('page_view', { page_type: 'landing' });
  iycTrackOnView(document.getElementById('iyc-exclusives'), 'view_exclusives');
  iycTrackOnView(document.getElementById('iyc-giveaway'), 'view_giveaway');
  iycTrackOnView(document.getElementById('iyc-offer'), 'view_offer');
  iycTrackOnView(document.getElementById('iyc-one-presale'), 'presale_clock_view');
  var iycUpdateSticky = iycInitSticky();
  iycInitLazyBg();
  iycInitViewer();
  iycInitClock();
  iycInitFaq();
  iycInitReminder();
  var iycOrder = iycInitOrder(iycUpdateSticky);
  /* KL1 05.10.2026: the country chooser inside the open layer switches in place (iycLandWechsel). Outside the layer
     (footer) it stays Shopify's normal form with a page load. */
  (function () {
    if (!iycOrder || !iycOrder.land || !window.fetch || !window.DOMParser || !window.FormData) return;
    var st = document.createElement('style');
    st.textContent = '#iyc-order.iyc-land-busy{cursor:progress}#iyc-order.iyc-land-busy .iyc-flow-main{opacity:.55;pointer-events:none;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){#iyc-order.iyc-land-busy .iyc-flow-main{transition:none}}';
    document.head.appendChild(st);
    var knopf = null;
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.iyc-lwk-liste button[name=country_code]');
      if (b) knopf = b;
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('iyc-lwk-form') || f.hasAttribute('data-iyc-nativ')) return;
      var ebene = document.getElementById('iyc-order');
      if (!ebene || ebene.hidden || !ebene.contains(f)) return;
      var b = e.submitter || knopf;
      var code = b && b.name === 'country_code' ? String(b.value || '') : '';
      if (!/^[A-Z]{2}$/.test(code)) return;
      e.preventDefault();
      var d = f.querySelector('details');
      if (d) d.open = false;
      if (code === (window.Shopify && window.Shopify.country)) return;
      iycOrder.land(f, code);
    });
  })();
  /* R4 30.09.2026: product pages open the order layer in place (sections/iyc-product.liquid), so the visitor stays
     on the product page and the checkout's cart icon (/cart, R1) brings them back there. */
  /* W2 02.10.2026: product pages open the layer with their selection while their cart write runs. */
  window.iycBestellenMit = function (st, writing) {
    return Boolean(iycOrder && iycOrder.openState && iycOrder.openState(st, writing));
  };
  window.iycBestellen = function (pre, source) {
    if (!iycOrder || !iycOrder.openPreset) return false;
    iycOrder.openPreset(pre === 'hardcover' || pre === 'ebook' ? pre : 'bundle', source || 'product_page');
    return true;
  };
  iycInitTrailer();
  iycInitCartDrawer(iycUpdateSticky, iycOrder);
  /* E1 24.09.2026: other pages send visitors here – /cart and the checkout's cart link as ?iyc_cart=1,
     product pages as ?iyc_order=<edition>. The parameter is removed from the address first, so Back
     and the X close the layer onto the clean start page. */
  /* E2 24.09.2026: arriving with an anchor (e.g. /#iyc-faq-title from another page), the browser jumps
     before lazy images and reveals settle, and the heading ends up under the fixed presale bar.
     Jump once more when the page has loaded (scroll-margin-top in CSS keeps it below the bar). */
  (function () {
    var h = location.hash && location.hash.length > 1 ? location.hash.slice(1) : '';
    if (!h || h.indexOf('=') !== -1) return;
    var ziel = document.getElementById(h);
    if (!ziel) return;
    var selbst = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.addEventListener(t, function () { selbst = true; }, { once: true, passive: true }); });
    var nochmal = function () { if (!selbst && Math.abs(ziel.getBoundingClientRect().top - 84) > 24) ziel.scrollIntoView({ block: 'start' }); };
    if (document.readyState === 'complete') setTimeout(nochmal, 150);
    else window.addEventListener('load', function () { setTimeout(nochmal, 150); }, { once: true });
  })();
  (function () {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var c = q.get('iyc_cart');
    var o = q.get('iyc_order');
    q.delete('iyc_cart');
    q.delete('iyc_order');
    var rest = q.toString();
    /* R1 30.09.2026 (Noah: stay on the page you are on when the cart opens): remember this page. /cart – also the
       checkout's cart icon, which always points to /cart – returns here with ?iyc_cart=1 (layout/theme.liquid).
       Not the pre-order page (opens its own layer), cart, checkout or account. */
    if (!document.getElementById('iyc-page-autofire') &&
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkouts?|account|pages\/pre-order)(?:[\/?#]|$)/i.test(location.pathname)) {
      try { sessionStorage.setItem('iycLetzteSeite', location.pathname + (rest ? '?' + rest : '')); } catch (e) {}
    }
    if (c === null && o === null) return;
    try { history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash); } catch (e) {}
    if (c !== null && iycCartDrawerApi.open) iycCartDrawerApi.open();
    else if (o !== null && iycOrder && iycOrder.openPreset) iycOrder.openPreset(o === 'hardcover' || o === 'ebook' ? o : 'bundle');
  })();
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#iyc-bottom-continue');
    if (!b) return;
    e.preventDefault();
    var ol = document.getElementById('iyc-order');
    var real = document.getElementById(ol && ol.classList.contains('iyc-cm-on') ? 'iyc-cm-go' : 'iyc-continue-checkout');
    if (real) real.click();
  });
})();
/* P9 29.09.2026: links straight into the checkout (cart view, team packs, product pages) take one click.
   A second tap while the checkout loads is ignored, so it cannot start a second checkout load. */
(function () {
  'use strict';
  if (window.iycKasseSperre) return;
  window.iycKasseSperre = true;
  var until = 0;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var href = a.getAttribute('href') || '';
    if (!/^\/(checkout(\?|$)|cart\/\d+:\d+)/.test(href)) return;
    var now = Date.now();
    if (now < until) { e.preventDefault(); return; }
    until = now + 4000;
    a.setAttribute('aria-busy', 'true');
  });
  window.addEventListener('pageshow', function () {
    until = 0;
    Array.prototype.forEach.call(document.querySelectorAll('a[aria-busy="true"]'), function (a) { a.removeAttribute('aria-busy'); });
  });
})();

/* M1 30.09.2026: measurement only – a click on an express button (Shop Pay, Apple Pay, Google Pay, PayPal)
   wherever Shopify renders them in the theme. Buttons inside iframes (PayPal) are caught via window blur. */
(function () {
  var SEL = 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, [data-shopify-buttoncontainer]';
  var zuletzt = 0;
  function melde() {
    if (Date.now() - zuletzt < 1500) return;
    zuletzt = Date.now();
    try { if (window.clarity) window.clarity('event', 'express_geklickt'); } catch (e) {}
  }
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(SEL)) melde();
  }, true);
  window.addEventListener('blur', function () {
    var a = document.activeElement;
    if (a && a.tagName === 'IFRAME' && a.closest && a.closest(SEL)) melde();
  });
})();
